export const subtitles = {
    "1": {
        "startTime": 15.77,
        "endTime": 24.12,
        "transcript": "Tuamta-llu cali can'giircuuciryaurcami alerquagurlua asgurcuutnek.",
        "translation": "Then when he started making blackfish traps, he instruced me on the [asgurcuutet]."
    },
    "2": {
        "startTime": 24.52,
        "endTime": 31.2,
        "transcript": "Kuimteńi tamaani Qissunami asgurcuucirluni alerqualua taluyilartuq.",
        "translation": "When he used an [asgurcuun] there in the Qissunaq river, he would instruct me as he fish trapped."
    },
    "3": {
        "startTime": 31.98,
        "endTime": 41.39,
        "transcript": "Cali tua-i pau͡gani kuicuarni kelumteńi uksuarmi aniullratni can'giircuutet civvluki.",
        "translation": "Also, when the creeks inland from the main river snowed in the winter, he set the blackfish traps."
    },
    "4": {
        "startTime": 41.39,
        "endTime": 45.15,
        "transcript": "Tua-i unugpak [?erneqir'uurturnaurtut].",
        "translation": "They would [be set] all night [?into the day]."
    },
    "5": {
        "startTime": 45.72,
        "endTime": 52.71,
        "transcript": "Piyaurcama wangnek tua-i alerquutai aturluki pingnaquraqlua.",
        "translation": "When I started going by myself, I would always try to heed his instructions."
    },
    "6": {
        "startTime": 54.19,
        "endTime": 65.29,
        "transcript": "Tua-llam caqerlua negirlua uatemteńi Qissunam ceńiini aqesgircuutnek, cukarak-llu kapuarrlukek.",
        "translation": "Then one day, I set willow ptarmigan snares downriver from us on the banks of Qissunaq, and stuck the stakes."
    },
    "7": {
        "startTime": 66.8,
        "endTime": 78.3,
        "transcript": "Tua-i-ll' maaten neganka takullemini piaqa ingna aqesgircuutemni ingna tungulria ingna tekicartu'rqa pekluni.",
        "translation": "Then when I went to check on my willow ptarmigan snares, I found something black moving as I was about to reach it."
    },
    "8": {
        "startTime": 78.38,
        "endTime": 82.38,
        "transcript": "Napingalliniluni imarmiutaq.",
        "translation": "Apparently, a mink had gotten caught."
    },
    "9": {
        "startTime": 82.71,
        "endTime": 91.14,
        "transcript": "Maaten imna pelacinaggaumilria-wa negaq tauna kepeksaitellia-llu.",
        "translation": "I found that while the snare was also just twine, it didn't cut it."
    },
    "10": {
        "startTime": 91.14,
        "endTime": 94.48,
        "transcript": "Qukamikun negalliniluni.",
        "translation": "It had gotten snared in its middle."
    },
    "11": {
        "startTime": 95.29,
        "endTime": 105.96,
        "transcript": "Qaill' tua-i picirkailamku kaugtuutarkamenk yuarlua tangvaglaamku ellii tuquciaqan imarmiutarnek.",
        "translation": "Since I didn't know what else to do, I looked for a club since I watched him kill minks."
    },
    "12": {
        "startTime": 105.96,
        "endTime": 112.77,
        "transcript": "Uyaqurrit, uyaqurrit teguqerluki qipngamni tua-i tangvaglaucimtun.",
        "translation": "I took its neck and twisted it as I used to watch."
    },
    "13": {
        "startTime": 113.25,
        "endTime": 115.55,
        "transcript": "Tau͡gaam tuquqainanrituq.",
        "translation": "But it didn't just die."
    },
    "14": {
        "startTime": 116.53,
        "endTime": 124.07,
        "transcript": "Qiptulliniut wani qet'nge'rmeng, inglugtun tau͡gaam tegulriani nutaan.",
        "translation": "They twist though they're held, but [die] when held on either side."
    },
    "15": {
        "startTime": 125.37,
        "endTime": 134.7,
        "transcript": "Pinauraanga, \"Tuaten-gguq pisciigataqata ircaqut qecuk'arluku tuqutellrat assinrulartuq.\" Alerqualua.",
        "translation": "He'd tell me, \"When they can't die like that, it's better to kill them by pulling their hearts.\" He instructed me."
    },
    "16": {
        "startTime": 135.63,
        "endTime": 138.86,
        "transcript": "Tua-i tuaten pituriluki.",
        "translation": "I started doing that."
    },
    "17": {
        "startTime": 138.86,
        "endTime": 151.49,
        "transcript": "Kapkaanarturyaurcama-llu yuilqumi anerteqaqan imarmiutaq tekitaqamku tua-i ircaqu͡ra qecuk'arluku egmian tuquq'ernaurtut.",
        "translation": "When I started trapping in the wilderness and mink is alive when I reach it, I'd pull out its heart, and they die right away."
    },
    "18": {
        "startTime": 152.34,
        "endTime": 165.84,
        "transcript": "Kaviaret tau͡gken cali kapkaanaq'ngamun tekitaqama tua-i ciugarrluku tau͡gaam uyaqurrit tuqucilartuq tangvagaqamni.",
        "translation": "However, when I come across a fox in a steel trap, I would watch him lift its head up and kill it by its neck."
    },
    "19": {
        "startTime": 165.84,
        "endTime": 168.89,
        "transcript": "Elliitun tua-i piuraqlua.",
        "translation": "I do it like him."
    },
    "20": {
        "startTime": 194.73,
        "endTime": 203.75,
        "transcript": "Tuamta-ll' nucirlua ayagyaurcama, alerqurnauraanga assi'irqan cella maligcuarturaqama kaviarnek",
        "translation": "Then when I started traveling with a gun, he would instruct me when the weather was good while chasing a fox"
    },
    "21": {
        "startTime": 204.32,
        "endTime": 214.17,
        "transcript": "\"Pitsaqa'artevkenaku pitaqekuvgu assiqan cella caviggalgira'arluten amiirrarniaran tuani.",
        "translation": "\"Should you catch it when the weather's good, bring a little knife and skin it there."
    },
    "22": {
        "startTime": 214.17,
        "endTime": 219.27,
        "transcript": "\"Uqamalkutaqevkenaku kemga ut'ruqu'urniaran.\"",
        "translation": "\"Don't weigh yourself down with its flesh and bring it home.\""
    },
    "23": {
        "startTime": 219.87,
        "endTime": 224.67,
        "transcript": "Tua-i tuatnaqarraallemni tangvaglaucimtun ellii",
        "translation": "When I first did that, as I used to watch him"
    },
    "24": {
        "startTime": 224.67,
        "endTime": 236.61,
        "transcript": "Pamyuit ullirtevkenaki, qaill' piluki keggmaqaraqarraarluki man'a pamyuq nucuglaraa.",
        "translation": "Without cutting the tail, he would somehow bite the tail and pull it out."
    },
    "25": {
        "startTime": 238.59,
        "endTime": 242.21,
        "transcript": "Tua-i au͡g'arnartuq im' pamyuq cavkenani.",
        "translation": "The tail would come off without a problem."
    },
    "26": {
        "startTime": 242.21,
        "endTime": 248.29,
        "transcript": "Tuatnaqarraallemni keggmaqtaryaaqekeka man'a qainga.",
        "translation": "When I first did that, I tried biting the skin here."
    },
    "27": {
        "startTime": 248.29,
        "endTime": 260.43,
        "transcript": "When I pulled the tail, I think I only took off the fur, but the skin was left.",
        "translation": "When I pulled the tail, I think I only took off the fur, but the skin was left."
    },
    "28": {
        "startTime": 260.87,
        "endTime": 266.29,
        "transcript": "Ak'aki neng'uq imna melquq pamyuq.",
        "translation": "So much of the tail fur stretched."
    },
    "29": {
        "startTime": 266.29,
        "endTime": 272.63,
        "transcript": "Quyanricaaqua. Tua-i katurqaarluku ut'rulluku.",
        "translation": "I wasn't happy. After I gathered it, I brought it home."
    },
    "30": {
        "startTime": 273.71,
        "endTime": 282.13,
        "transcript": "Tauna-llu pamyua kepluku, enra kepluku piciqngaku elliin tekiskema.",
        "translation": "And I cut that tail, cut the bone, because that's what he used to do."
    },
    "31": {
        "startTime": 282.3,
        "endTime": 288.35,
        "transcript": "Tua-i tekicama mingqucelluki aanamnun tamakut amia au͡g'arraarluku.",
        "translation": "When I arrived, I had my mother sew them on after I removed the skin."
    },
    "32": {
        "startTime": 288.35,
        "endTime": 293.83,
        "transcript": "She sewed the fur on and made it into a tail.",
        "translation": "She sewed the fur on and made it into a tail."
    },
    "33": {
        "startTime": 293.94,
        "endTime": 302.76,
        "transcript": "Alerqualua nutaan pianga carrarmek-wa caquqerluki keggmaqa'arlaasqelluki qamkut",
        "translation": "He finally instructed me to cover them with something and bite deep inside"
    },
    "34": {
        "startTime": 303.14,
        "endTime": 307.93,
        "transcript": "Kiitellratnun amiit tamakut.",
        "translation": "Until those skins come off."
    },
    "35": {
        "startTime": 308.84,
        "endTime": 315.32,
        "transcript": "Cenkarmek tau͡gken piaqama qaill' tuqutesciigat'la'rqa anerteqaqan.",
        "translation": "However, when I catch a land otter, I can't kill it when it's alive."
    },
    "36": {
        "startTime": 315.75,
        "endTime": 321.53,
        "transcript": "Tuquqainayuituq, cenkaat.",
        "translation": "It doesn't easily die, land otters."
    },
    "37": {
        "startTime": 322.07,
        "endTime": 331.18,
        "transcript": "Tua-i cayaqlirluku tua-i kaugtuarpaka'arqamni ilii tuquurainalartuq.",
        "translation": "When I keep bashing them, some of them finally steadily die."
    },
    "38": {
        "startTime": 333.4,
        "endTime": 341.38,
        "transcript": "Mermiut pingrilnguut, mermiut piaqameng, eplalliniut egmianun mermetaqameng.",
        "translation": "Non-aquatic animals apparently drown right away in water."
    },
    "39": {
        "startTime": 342.06,
        "endTime": 349.1,
        "transcript": "Tua-i tamakut pissuryarat alerquutai piyaurcama tua-i aturturluki.",
        "translation": "When I started, I followed his instructions on hunting."
    },
    "40": {
        "startTime": 349.4,
        "endTime": 359.88,
        "transcript": "Catairut'ng'ermi-llu tua-i alerqualua tuaten piurlaasqellua tua-i alerquucimitun.",
        "translation": "And even if he's gone, he instructed me to do that according to his instruction."
    },
    "41": {
        "startTime": 386.7,
        "endTime": 394.36,
        "transcript": "Uum cali maliksaurcamia Peqiciram atiin cavailegmi, ug'um Peqiciram atii",
        "translation": "When Peqiciraq's father starting going with me before he passed away, Peqiciraq's father downriver"
    },
    "42": {
        "startTime": 394.46,
        "endTime": 399.79,
        "transcript": "Cali nutaan yuilqumun ayagallua yaaqvanun qimugtetgun.",
        "translation": "He brought me deep in to the wilderness far away by dog sled."
    },
    "43": {
        "startTime": 400.16,
        "endTime": 402.61,
        "transcript": "Maligqura'aqluku.",
        "translation": "I followed him."
    },
    "44": {
        "startTime": 402.61,
        "endTime": 408.37,
        "transcript": "[?Ciisqeḿaqlemteńi] uivluku pissuuteturaqlunuk.",
        "translation": "We'd go around [?] and hunted."
    },
    "45": {
        "startTime": 408.6,
        "endTime": 418.42,
        "transcript": "Unavet cali ayagaqamnuk Qucilgaq uivluku tamaani pitulunuk.",
        "translation": "And when we went down there, going around Qucilgaq, we'd [hunt] there."
    },
    "46": {
        "startTime": 425.0,
        "endTime": 428.71,
        "transcript": "Ii-i, qanerturluten arulairpek'nak. (Ai?) Qanerturluten.",
        "translation": "Okay, keep speaking, don't stop. (What?) Keep speaking."
    },
    "47": {
        "startTime": 428.71,
        "endTime": 434.49,
        "transcript": "Tua-i Qucilgaq uivaqamegnegu qimugtetgun calanrituq.",
        "translation": "When we went around Qucilgaq by dog sled, nothing would happen."
    },
    "48": {
        "startTime": 434.62,
        "endTime": 444.97,
        "transcript": "Tau͡gaam up'nerkami qayakun malikaqamku, up'nerkilaami uani uatemteńi Quuqamek pilallratni",
        "translation": "But when I went with him in the spring by kayak, because he would set up spring camp downriver from us where they called it Quuqaq"
    },
    "49": {
        "startTime": 445.1,
        "endTime": 451.77,
        "transcript": "Atairutma tekitellrani pia qanrulluku",
        "translation": "When my late father arrived, he told him"
    },
    "50": {
        "startTime": 452.32,
        "endTime": 459.43,
        "transcript": "\"Tauna anelraulluku cakmani. Uum-llu anngiin ayagasngaitaa,\" Eritailnguq piluku.",
        "translation": "\"Take him downriver. His brother won't travel with him, \" referring to Eritailnguq."
    },
    "51": {
        "startTime": 459.81,
        "endTime": 466.37,
        "transcript": "\"Ayagaqurarru cakmani nunavni. Anelraa.\" Malikuraasqellua.",
        "translation": "\"Take him to your village downriver. Go downriver.\" He told me to follow along."
    },
    "52": {
        "startTime": 466.77,
        "endTime": 470.6,
        "transcript": "Tua-i qayakun uivaqamegnegu Qucilgaq",
        "translation": "When we went around Qucilgaq by kayak"
    },
    "53": {
        "startTime": 471.18,
        "endTime": 477.73,
        "transcript": "Ciuqlirmi piqarraallemegni tevcarat yuaqaqluki.",
        "translation": "When we first did it, we'd look for portage routes."
    },
    "54": {
        "startTime": 478.99,
        "endTime": 483.64,
        "transcript": "Kepngamegnegu kelutmun, nanvamun qakvaamnuk",
        "translation": "When we cut inland through there and came up on a lake"
    },
    "55": {
        "startTime": 483.9,
        "endTime": 490.78,
        "transcript": "Tevcarat yuaqaqluki tamaaggun, tamaavet-gguq Elurtulim kangranun.",
        "translation": "We'd look for portage route through there, to the headwaters of what they called Elurtuli."
    },
    "56": {
        "startTime": 491.25,
        "endTime": 498.21,
        "transcript": "Tua-i kanaamegen'gu carvanian uatmun nutaan cetulunuk.",
        "translation": "When we went down to it, since the currrent was strong, we went downriver."
    },
    "57": {
        "startTime": 498.54,
        "endTime": 507.95,
        "transcript": "Nequturian-ll' un'gani akiqliqu'urlunuk anguanglunuk kanaqlagcurlunuk.",
        "translation": "And when it widened downriver, we started rowing side by side hunting for muskrats."
    },
    "58": {
        "startTime": 508.29,
        "endTime": 515.85,
        "transcript": "Tua-i pivakarlunuk iliikun cenkarmek-ll' pairkengnaurtukuk tamaani pilrianek.",
        "translation": "As we went, we'd sometimes pass land otters swimming there."
    },
    "59": {
        "startTime": 517.82,
        "endTime": 526.43,
        "transcript": "Tua-llam caqerlunuk cenkarnek pillmegni igvaarrluki ua-i qanikcarkun tagluteng.",
        "translation": "Then as we saw land otters, we appeared on them going up to the land through the snow."
    },
    "60": {
        "startTime": 526.76,
        "endTime": 530.85,
        "transcript": "Cetamauluteng, aanameggnek cunaw' ilangqellinilriit.",
        "translation": "There were four, apparently with their mother."
    },
    "61": {
        "startTime": 531.04,
        "endTime": 537.81,
        "transcript": "Pianga, \"Kitaki tevcaraulliata tuaggun tev'ut.\"",
        "translation": "He said to me, \"Okay, they're going through there probably because it's a portage route.\""
    },
    "62": {
        "startTime": 537.81,
        "endTime": 540.28,
        "transcript": "Maligarrluki tua-i.",
        "translation": "We followed them."
    },
    "63": {
        "startTime": 542.76,
        "endTime": 546.72,
        "transcript": "Nutka teguluku, qayaqa unilluku, maligarrluki.",
        "translation": "I took my gun, left my kayak, and followed them."
    },
    "64": {
        "startTime": 546.72,
        "endTime": 554.88,
        "transcript": "Qau͡ga-i tangrramki nanvarrarmun kanalliniluteng. Nanvarraq uivarrluku.",
        "translation": "When I saw them upriver, they went to a pond. We went around the pond."
    },
    "65": {
        "startTime": 554.96,
        "endTime": 558.3,
        "transcript": "Pika-i qakvaata ullagluki.",
        "translation": "When they went out up there, we went to them."
    },
    "66": {
        "startTime": 558.54,
        "endTime": 569.62,
        "transcript": "Maaten imna tekitanka tevcaratgun tumlliut. Maa-i-ll' ataam kuigmun tamaavet Elurtulimun una ava-i kanalliniluteng.",
        "translation": "I arrived there and found tracks on the portage route. And they went down to the river again, here to Elurtuli."
    },
    "67": {
        "startTime": 570.74,
        "endTime": 574.53,
        "transcript": "Alakarrlua tuani tangrramegteńga.",
        "translation": "They noticed me when they saw me."
    },
    "68": {
        "startTime": 575.01,
        "endTime": 578.93,
        "transcript": "Taqililuteng puguralartut tamakut cenkaat.",
        "translation": "Those land otters [?] when they appear."
    },
    "69": {
        "startTime": 579.09,
        "endTime": 587.04,
        "transcript": "Taikanirluteng pugurallratni uirraluteng, tuaten aaniit tauna.",
        "translation": "When they appeared coming closer, they growled, even their mother."
    },
    "70": {
        "startTime": 587.95,
        "endTime": 593.42,
        "transcript": "Nutegluku, taqinarpek'naku tau͡gaam.",
        "translation": "I shot it, but didn't instantly kill it."
    },
    "71": {
        "startTime": 595.34,
        "endTime": 604.31,
        "transcript": "Ayanrilan, ika-i akimnun tagngan can'gurnermun nutaan qayaqa aqvaluku.",
        "translation": "When he didn't go, since he went up to the grassy area across from me, I went to get my kayak."
    },
    "72": {
        "startTime": 604.31,
        "endTime": 606.36,
        "transcript": "Utaqaurallinilua.",
        "translation": "He was waiting for me."
    },
    "73": {
        "startTime": 606.36,
        "endTime": 616.55,
        "transcript": "Pianga, \"Kuigmun kanaqata mat'um ilakaa. Wii uivurciqua anguarturlua. Elpet tevluten tuaggun maliggluki.\"",
        "translation": "He said to me, \"If they go down to the river, it's part of this. I will go around rowing. You portage through there with them.\""
    },
    "74": {
        "startTime": 616.55,
        "endTime": 622.29,
        "transcript": "Tauna tayim' tuqungraan-tuq akma nall'artellruku un' aniit.",
        "translation": "Though their mother died across there, I hoped he'd come across it."
    },
    "75": {
        "startTime": 647.85,
        "endTime": 652.22,
        "transcript": "Tua-i qerarlua. Aturkuki tevcarat tevlua.",
        "translation": "I crossed. I portaged through the route."
    },
    "76": {
        "startTime": 652.53,
        "endTime": 659.01,
        "transcript": "Tekicamku qayaqa atrarrluku piaqa tuquksaitelliuq cali.",
        "translation": "When I got to it and lowered my kayak, I saw that it hadn't died yet."
    },
    "77": {
        "startTime": 659.33,
        "endTime": 665.06,
        "transcript": "Tekicamni atraqerrluni tau͡gaam elluaciqevkenani.",
        "translation": "When I reached it, it went down, but it wasn't doing very well."
    },
    "78": {
        "startTime": 665.55,
        "endTime": 671.18,
        "transcript": "Twenty-two-ngqerrama canimelan pulngarrluku nutaan pitaqluku.",
        "translation": "Since I had a .22 and it was close, I shot it again and caught it."
    },
    "79": {
        "startTime": 671.18,
        "endTime": 677.41,
        "transcript": "Irniari tau͡gken maani au͡gatemni piluteng, puguraluteng.",
        "translation": "Its young, however, were popping up around me here."
    },
    "80": {
        "startTime": 679.27,
        "endTime": 682.44,
        "transcript": "Tua-i nut'gayaaqluki.",
        "translation": "I tried shooting at them."
    },
    "81": {
        "startTime": 682.44,
        "endTime": 688.42,
        "transcript": "Pitangyugpakarluki anagialuki. Tamariluki tayima.",
        "translation": "Since I was in too much of a hunting frenzy, they ran away from me. I lost them."
    },
    "82": {
        "startTime": 689.1,
        "endTime": 691.36,
        "transcript": "Tauna tau͡gaam aaniit.",
        "translation": "[I only caught] their mother."
    },
    "83": {
        "startTime": 691.36,
        "endTime": 695.31,
        "transcript": "Utaqaurluku tauna malika.",
        "translation": "I waited for my companion."
    },
    "84": {
        "startTime": 695.31,
        "endTime": 700.85,
        "transcript": "Muluuraqerluni yaaqsilliniami cingik tamana.",
        "translation": "He tarried since that point was far."
    },
    "85": {
        "startTime": 701.32,
        "endTime": 706.25,
        "transcript": "Ama-i cingqullagtuq yaaqsigpek'nani.",
        "translation": "He made a [gun] popping sound over there not far away."
    },
    "86": {
        "startTime": 708.0,
        "endTime": 716.51,
        "transcript": "Tekicami pianga, ataucimek-gguq cenkarmek tuani pairrluku nutegtuq.",
        "translation": "He said when he arrived that he passed one land otter there and shot."
    },
    "87": {
        "startTime": 716.88,
        "endTime": 724.38,
        "transcript": "Pianga, \"Taukut piyagaat ilakngataat. Piyagaunrituq-gguq. Angelriaruuq-gguq.\"",
        "translation": "He said to me, \"I think it's one of those young ones. It's not young. It's big.\""
    },
    "88": {
        "startTime": 724.45,
        "endTime": 735.5,
        "transcript": "Piyagai taukut tayim' tamariamki pianga, \"Taglunuk-wa piani nunapigmi qavartara'arluk unugpak anguallruamnuk.",
        "translation": "When I lost those young, he said to me, \"We should go inland and set up camp on the tundra since we rowed all night."
    },
    "89": {
        "startTime": 736.47,
        "endTime": 746.59,
        "transcript": "\"Qavarta'arluk piani nunapiim qainganun qayapuk tagulluki.\" Uciirlunuk tagulluki.",
        "translation": "\"Let's set up camp inland on the tundra and bring up our kayaks.\" We unloaded and brought them up."
    },
    "90": {
        "startTime": 747.76,
        "endTime": 756.2,
        "transcript": "Tamaaken uqviarrlunuk pilunuk. Cainiliurlunuk yuuraqara'arrlunuk. Quunirluni.",
        "translation": "We gathered willows there. We made a kettle of hot water and drank something hot. The weather was calm."
    },
    "91": {
        "startTime": 757.29,
        "endTime": 768.07,
        "transcript": "Piqerluni pianga, \"Atam igvalria cakem' kanaqlaunritell'. Min'get unegkut ukatmurtellriit.\"",
        "translation": "As we were there, he said to me, \"Look, something that's not a muskrat appeared downriver. The wake of something is coming from downriver.\""
    },
    "92": {
        "startTime": 768.43,
        "endTime": 774.34,
        "transcript": "Maaten piaqa minegpaggauluteng. Kanaqlauvkenani.",
        "translation": "I saw that it left a big wake. It wasn't a muskrat."
    },
    "93": {
        "startTime": 774.86,
        "endTime": 782.86,
        "transcript": "Igvaqerluni-ll' tayima, tagngami tayima alainqigtevkenani.",
        "translation": "When it appeared and went inland, it didn't appear again."
    },
    "94": {
        "startTime": 782.86,
        "endTime": 788.7,
        "transcript": "Pianga, \"Nunii ugna paqteqarru qayan atrarrluku.\"",
        "translation": "He said to me, \"Take down your kayak and check where it went downriver.\""
    },
    "95": {
        "startTime": 789.14,
        "endTime": 798.24,
        "transcript": "Maaten imna tauna min'girtellran nunii tekitaqa tevcaraullinilriit makut.",
        "translation": "I reached where its wake ended, and found a portage route here."
    },
    "96": {
        "startTime": 798.24,
        "endTime": 806.92,
        "transcript": "Culurrlua tuavet, .22-q teguluku, taglua maliggluku.",
        "translation": "I docked there, took the .22, and went inland along it."
    },
    "97": {
        "startTime": 806.92,
        "endTime": 817.65,
        "transcript": "Nanvarrarni piani keluqvaarni kanartua, kanani cikumi kan'a tungulria pektaqluni.",
        "translation": "I went down to a pond far inland, and something black down on the ice would move."
    },
    "98": {
        "startTime": 817.65,
        "endTime": 820.4,
        "transcript": "Taungulliniluni.",
        "translation": "It was that thing."
    },
    "99": {
        "startTime": 824.07,
        "endTime": 830.61,
        "transcript": "Malruurrlutek avvlutek, ataam katurtaqlutek.",
        "translation": "It would split into two, then come together again."
    },
    "100": {
        "startTime": 855.97,
        "endTime": 862.45,
        "transcript": "Atauciq tauna tuunrituli Qupanuarmek pilallrat",
        "translation": "That one who had shamanistic powers whom they called Qupanuaq"
    },
    "101": {
        "startTime": 862.45,
        "endTime": 868.28,
        "transcript": "Tua-i ataucirquunrilngurmek takumni tuunriqaqulartuq.",
        "translation": "He's excercised his shamanistic powers in front of me more than once."
    },
    "102": {
        "startTime": 869.53,
        "endTime": 874.89,
        "transcript": "Tua-i caqerlua Cuukvagtulimun maligullua, tuantelliniluni.",
        "translation": "One time, I followed people to Cuukvagtuli, and he was there."
    },
    "103": {
        "startTime": 876.52,
        "endTime": 883.19,
        "transcript": "Tuunrivkallratni-am qasgimi atairutka-ll' maligucami aturteńgulaami",
        "translation": "When they had him call upon his spirit helpers in the community house, and my late father went since he was a singer"
    },
    "104": {
        "startTime": 883.19,
        "endTime": 887.89,
        "transcript": "Akiqliqluteng cauyarluteng qasgimi aturlaameng.",
        "translation": "They drummed side by side since they sang in the community house."
    },
    "105": {
        "startTime": 888.72,
        "endTime": 892.53,
        "transcript": "Qavaqallinilua cauyalriik taukuk.",
        "translation": "I fell asleep [betwen] those two drummers."
    },
    "106": {
        "startTime": 892.93,
        "endTime": 902.09,
        "transcript": "Una wani Nick Beans-aq canimni, anngaqa-llu akunleragni wii qavarlua, qavallinilua.",
        "translation": "I fell asleep between Nick Beans beside me, and my older brother."
    },
    "107": {
        "startTime": 902.41,
        "endTime": 911.61,
        "transcript": "Tua-i tupak'artua qasgi man'a cingqullagluni, aglut pagkut imluteng ayimqelluteng.",
        "translation": "I woke up to the community house here cracking loudly, the center beams up there splitting and caving in."
    },
    "108": {
        "startTime": 911.84,
        "endTime": 919.48,
        "transcript": "Tua-i mak'aruciqa tau͡gaam tua-i. Temlilua qavamni.",
        "translation": "That was all I awoke to. I had apparently had a lucid dream."
    },
    "109": {
        "startTime": 919.48,
        "endTime": 929.99,
        "transcript": "Cauyat kaugtullratni cingqullalriaruluki pagkuuluki aglut, ayimqellriaruluki niigarrluki.",
        "translation": "With the pounding drums, I heard them as the center beams up there cracking loudly as they split."
    },
    "110": {
        "startTime": 929.99,
        "endTime": 933.31,
        "transcript": "Anqerrnalua umyuarteqellrianga tayima.",
        "translation": "I had the thought to run out."
    },
    "111": {
        "startTime": 933.45,
        "endTime": 942.22,
        "transcript": "Maklua qaniqnginanrani tauna uani amigmi imarnitegnek uligluni.",
        "translation": "I got up as he was saying his shamanistic incantation at the door, with [the patient] covered with a seal gut rain parka."
    },
    "112": {
        "startTime": 942.22,
        "endTime": 946.82,
        "transcript": "Ukuk-llu elucira'artek nangengqalutek-am.",
        "translation": "And these two dancers were standing."
    },
    "113": {
        "startTime": 947.49,
        "endTime": 956.95,
        "transcript": "Tekicamku-gguq tauna qaniqellria teguluku maaggun nuqtaqa, kanavet-llu nacitnun aqumkallagluni.",
        "translation": "They said that when I reached the shaman incanting, I took him here, pulled, and he fell on his behind down on the floor plank."
    },
    "114": {
        "startTime": 959.09,
        "endTime": 968.46,
        "transcript": "Tua-i-gguq qaill' picirkailami atairutma pia, \"Aullu-wa-i piluaqanritaaten. Taum picurlagaaten.",
        "translation": "They said since my later father couldn't do anything, he told me, \"My goodness, he didn't do something good to you. He scorned you."
    },
    "115": {
        "startTime": 968.46,
        "endTime": 972.97,
        "transcript": "\"Temliuq-am. Temlituuq. Temliluni piaten.\"",
        "translation": "\"He's sleepwalking again. He sleepwalks. He did that to you sleepwalking.\""
    },
    "116": {
        "startTime": 973.67,
        "endTime": 982.35,
        "transcript": "Tua-i aqumngami-gguq Qupanuaq qanertuq, \"Temlikuni-gguq, qavamini pikuni picurlanrilkiinga.\"",
        "translation": "They said when Qupanuaq sat up, he said, \"If he's sleepwalking, if he did it in his sleep, he didn't scorn me.\""
    },
    "117": {
        "startTime": 983.63,
        "endTime": 988.36,
        "transcript": "Canritniluku. Canritniluni.",
        "translation": "He said it was fine. He said he was fine."
    },
    "118": {
        "startTime": 988.36,
        "endTime": 995.61,
        "transcript": "Tua-i ciinllugguaralua. Itraama anqertellinilua.",
        "translation": "I regretted it. When I went in, I ran out."
    },
    "119": {
        "startTime": 996.34,
        "endTime": 1004.53,
        "transcript": "Tau͡gaam qanrutenritaanga [?] Nick Beans-am. Maaten tekitaqa una nayangarluni aqumgaurluni.",
        "translation": "But Nick Beans didn't say anything to me. I reached him and found that he was nodding as he was sitting."
    },
    "120": {
        "startTime": 1004.69,
        "endTime": 1008.43,
        "transcript": "Cunaw' engelarciiganani yugyiimi qasgi.",
        "translation": "It turned out he couldn't laugh because there was a lot of people in the community house."
    },
    "121": {
        "startTime": 1008.5,
        "endTime": 1013.92,
        "transcript": "Tua-i waten tau͡gaam piurluni, uitavkenani tua-i.",
        "translation": "He only did this, not staying still."
    },
    "122": {
        "startTime": 1013.92,
        "endTime": 1017.58,
        "transcript": "Temciyugyaaqluni engelarluni pisciiganani.",
        "translation": "He found it funny, but couldn't laugh."
    },
    "123": {
        "startTime": 1018.26,
        "endTime": 1024.61,
        "transcript": "Tua-i ataam inarrlua, qavallinilua nutaan tayima.",
        "translation": "I lay down again and was asleep for good."
    },
    "124": {
        "startTime": 1024.93,
        "endTime": 1028.88,
        "transcript": "Tuani-llu unuaquani-ll' qanrutevkenii tamaani.",
        "translation": "And the next day, they didn't tell me there."
    },
    "125": {
        "startTime": 1028.88,
        "endTime": 1035.96,
        "transcript": "Cuqartalegmun tau͡gaam tekicamta utercamta nutaan aanairutka qanemcilluku Nick Beans-am",
        "translation": "Only when we returned to Cuqartalek, Nick Beans told my late mother the story"
    },
    "126": {
        "startTime": 1035.96,
        "endTime": 1040.82,
        "transcript": "Tangvalliniamia tuani Qupanuaq tauna aqumkallagcetlemni.",
        "translation": "Since he watched me making Qupanuaq fall on his behind then."
    },
    "127": {
        "startTime": 1042.96,
        "endTime": 1052.24,
        "transcript": "Qacigtenricaaqut-gguq nepailameng. Qasgimi tua-i engelarciiganateng yugyaam[eng] tuunriameng.",
        "translation": "They said it was hard because they were quiet. They couldn't laugh in the community house because the shaman was practicing his powers in front of many people."
    },
    "128": {
        "startTime": 1052.24,
        "endTime": 1060.96,
        "transcript": "Taukuk-llu eluciraralriik tekicamkek mengelvartaarraarlukek anqerrlua.",
        "translation": "And when I reached the two dancers, I pushed them to the side and ran out."
    },
    "129": {
        "startTime": 1060.96,
        "endTime": 1068.36,
        "transcript": "Kamilangqiima kumlangata tau͡gaam elaturrami amigmi it'ganka kumlangata tupaglua.",
        "translation": "Since I was barefoot, when my feet got cold in the door of the entry porch, I woke up."
    },
    "130": {
        "startTime": 1069.18,
        "endTime": 1077.4,
        "transcript": "Pam'um nuqtaqiinga tunumnek. Maaten kingyarlua piaqa anngairutma nuqtallianga itrullua.",
        "translation": "Someone behind me pulled me from my back. I looked back and saw that my late older brother was pulling me inside."
    },
    "131": {
        "startTime": 1079.53,
        "endTime": 1087.78,
        "transcript": "Kiaresngaacaaqellrianga cakneq qaill' picirkailama, temlilliniama-am tuani.",
        "translation": "I felt very awkward because I couldn't do anything since I sleepwalked there."
    },
    "132": {
        "startTime": 1088.26,
        "endTime": 1095.73,
        "transcript": "Tau͡gaam tekicama nutaan Nick Beans-am aanairutka qanemcilluku.",
        "translation": "Only when I arrived did Nick Beans tell my late mother the story."
    },
    "133": {
        "startTime": 1120.71,
        "endTime": 1132.3,
        "transcript": "Qanruyutengqellruukut arnani atakumi-llu tarritesqevkenata, ullagatesqevkenata-llu.",
        "translation": "We women had traditional wisdom not to wanter in the evening, and not to have guests."
    },
    "134": {
        "startTime": 1132.62,
        "endTime": 1144.04,
        "transcript": "Una tua-i wiii aanamnek arcaqerluku, aanamnek atamnek-llu waten:",
        "translation": "This was important [wisdom] from my mother, my mother and father:"
    },
    "135": {
        "startTime": 1144.04,
        "endTime": 1150.74,
        "transcript": "Qalartellriik-gguq camek assiilngurmek niicugninrillakek.",
        "translation": "They said I shouldn't listen to people speaking bad things."
    },
    "136": {
        "startTime": 1151.82,
        "endTime": 1162.28,
        "transcript": "Tua-ll' qalarucilriamek tangerquma, qalarucilriamek tangerquma",
        "translation": "Then if I see someone giving instruction, if I see something giving instruction"
    },
    "137": {
        "startTime": 1163.64,
        "endTime": 1171.97,
        "transcript": "Ullagluku nutaan niicugnisqelluku inerquutnek qalartellria.",
        "translation": "They told me to go and listen to the one speaking about admonishments."
    },
    "138": {
        "startTime": 1172.42,
        "endTime": 1175.33,
        "transcript": "Tamaani nepaitellruut.",
        "translation": "They were peaceful back then."
    },
    "139": {
        "startTime": 1175.33,
        "endTime": 1181.84,
        "transcript": "Tau͡gaam qaneryaram mat'um qanrutkellrit makut wani",
        "translation": "But these things that traditional wisdom speaks about"
    },
    "140": {
        "startTime": 1183.81,
        "endTime": 1190.55,
        "transcript": "Qanrutkumalria tekirqeput. Murilkelluci elpeci yuuci.",
        "translation": "We come to the time spoken about. You, live carefully."
    },
    "141": {
        "startTime": 1191.28,
        "endTime": 1194.28,
        "transcript": "Murilkengnaqluci",
        "translation": "Try to be careful"
    },
    "142": {
        "startTime": 1194.38,
        "endTime": 1204.68,
        "transcript": "Una tekitaqan tangnerrarpek'naku elitaq'larnaurci, cangayung'erpeci-llu cangakevkenaku.",
        "translation": "So that you will not be surprised but recognize what you come across, and not be taken aback though you do not find it right."
    },
    "143": {
        "startTime": 1206.57,
        "endTime": 1215.95,
        "transcript": "Una-llu qanlerayulria angun wall'u arnaq, qastuluni qalarculria",
        "translation": "And this man or woman that speaks harshly, one who speaks loudly"
    },
    "144": {
        "startTime": 1215.95,
        "endTime": 1219.94,
        "transcript": "Tauna tua-i assikevkenaku.",
        "translation": "They do not like that."
    },
    "145": {
        "startTime": 1221.87,
        "endTime": 1234.01,
        "transcript": "Waten-llu tan'gaurluq ayagyuaq takuanun qanleralluku yugnek niitesterluni callallerkaa umyuaqevkenaku",
        "translation": "And speaking harshly to this young boy with people listening without regard to how he will react"
    },
    "146": {
        "startTime": 1234.01,
        "endTime": 1241.81,
        "transcript": "Tamaa-i tamana caniluku.",
        "translation": "They said something was wrong with it."
    },
    "147": {
        "startTime": 1242.74,
        "endTime": 1245.92,
        "transcript": "Tua-i mat'um nalliini",
        "translation": "These days"
    },
    "148": {
        "startTime": 1246.86,
        "endTime": 1256.89,
        "transcript": "Qanruyutvut man'a eneqangluku-ll' wii caknengama tutgaramnek wall'u makunek yumnek",
        "translation": "Because I remember our traditional wisdom and struggle with my grandchildren or my children here"
    },
    "149": {
        "startTime": 1256.89,
        "endTime": 1259.87,
        "transcript": "Caknengama eneqangluku",
        "translation": "Since I remember it and struggle"
    },
    "150": {
        "startTime": 1261.32,
        "endTime": 1274.53,
        "transcript": "Qanpagayulria tauna, qastuluni qalarculria atawakevkenaku.",
        "translation": "I think that person who shouts, who speaks loudly, is not good."
    },
    "151": {
        "startTime": 1298.45,
        "endTime": 1304.57,
        "transcript": "Ellangeqarraallemni imkut qanrutetullruatnga",
        "translation": "In my earliest memories, the poeple back then used to tell me"
    },
    "152": {
        "startTime": 1304.94,
        "endTime": 1310.46,
        "transcript": "Umyuartungnaqlua-gguq usvitungnaqlua yuukilii.",
        "translation": "That I should try to live mindfully and wisely."
    },
    "153": {
        "startTime": 1311.96,
        "endTime": 1324.21,
        "transcript": "Tua-i-llu angliriama tarricaurcama maani, ikamranun-llu maligucaurcama qanrutnauraatnga waten:",
        "translation": "Then when I grew up and started traveling here, and went with those traveling by dog team, they would tell me this:"
    },
    "154": {
        "startTime": 1324.79,
        "endTime": 1335.99,
        "transcript": "Atam-gguq piyaureskuma, unangyaureskuma yuilqurmiutarnek, imarpiim-ll' unkunek piinek",
        "translation": "Watch, they said, when I became able and start catching animals from the wilderness and from the ocean down there"
    },
    "155": {
        "startTime": 1336.99,
        "endTime": 1341.88,
        "transcript": "Amirkaq-gguq una atauciq qemangqaurqumku",
        "translation": "They said if I keep this one sealskin with me"
    },
    "156": {
        "startTime": 1341.88,
        "endTime": 1350.44,
        "transcript": "Atam-gguq ilangelarniartuq, kiituani-gguq qayarkanrurcan qayaqsagutaqua, qayangua tua-i.",
        "translation": "Watch, they said, there will be more, and when they eventually become enough for a kayak, I will get a kayak."
    },
    "157": {
        "startTime": 1351.01,
        "endTime": 1359.23,
        "transcript": "Tuamtellu-gguq pavani yuilqumi imarmiutarmek wall'u tevyulimek unangekuma",
        "translation": "Then they said that if I catch a mink or a muskrat in the wilderness inland"
    },
    "158": {
        "startTime": 1359.6,
        "endTime": 1365.59,
        "transcript": "Akia-gguq atam qemangqaurqumku egmianun tunevkenaku",
        "translation": "Watch, they said, if I save the money without handing it over right away"
    },
    "159": {
        "startTime": 1365.72,
        "endTime": 1374.53,
        "transcript": "Carrarmun-gguq atam nutaan kinguqvaarni ilakangkan tunkumku piluaqerniartua.",
        "translation": "They said I would do well if I use it for something later when I add to it."
    },
    "160": {
        "startTime": 1374.68,
        "endTime": 1387.43,
        "transcript": "\"Umyugailkuvet, umyugailkuvet ilavnek ayuqniallren egmiuciiqan",
        "translation": "\"If you are mindless, you will go forth coveting those around you"
    },
    "161": {
        "startTime": 1388.31,
        "endTime": 1393.88,
        "transcript": "\"Ilaten atu'urkameggnek teguqerrartengraata.\"",
        "translation": "\"Though those around you get their hands on what they need.\""
    },
    "162": {
        "startTime": 1394.08,
        "endTime": 1403.59,
        "transcript": "Tua-i umyugaitelliniama ilanka teguqerrartengraata ayuqniarumallruanka.",
        "translation": "Since I'm apparently mindless, though those around me got their hands on things, I coveted them for a long time."
    },
    "163": {
        "startTime": 1436.41,
        "endTime": 1446.77,
        "transcript": "Makut maa-i akingukarani check-at quyurquranritlinikai.",
        "translation": "He apparently didn't save up what money he got through checks."
    },
    "164": {
        "startTime": 1447.39,
        "endTime": 1455.1,
        "transcript": "Akingukarani check-at imarkilengraata quyurqurquniki",
        "translation": "If he saves what money he gets though the checks are small"
    },
    "165": {
        "startTime": 1455.4,
        "endTime": 1461.98,
        "transcript": "Amllerikata tua-i snuukuuq akilicugngariyaryalliniluku.",
        "translation": "When they amass, he'd be able to pay for a snow machine."
    },
    "166": {
        "startTime": 1462.63,
        "endTime": 1470.53,
        "transcript": "Massiinaq-llu levaaq akilicugngayalliniluku.",
        "translation": "And he'd be able to pay for a boat motor."
    },
    "167": {
        "startTime": 1470.8,
        "endTime": 1481.07,
        "transcript": "Anirtima qanrutaitkut, akikaar-gguq kiturtelluku, egmianun kiturtelluku tun'urluku",
        "translation": "It's no wonder they told us that letting what money we have pass by, letting it pass by right away by spending it"
    },
    "168": {
        "startTime": 1481.07,
        "endTime": 1490.16,
        "transcript": "Kipusviit iluatni canek aturanek cucullerput, maligtaquurassiyaagluku umyuarput.",
        "translation": "Getting things we want inside stores, giving in to our first inclinations too much."
    },
    "169": {
        "startTime": 1490.49,
        "endTime": 1495.99,
        "transcript": "Kiturtelluki-gguq akikaaraput tamakut aklungengaitukut.",
        "translation": "They said if we let what little money we have pass by, we won't have things."
    },
    "170": {
        "startTime": 1495.99,
        "endTime": 1503.19,
        "transcript": "Angyangengaunata-llu akitulriamek, massiinangengaunata-llu akitulriamek.",
        "translation": "We won't get an expensive boat, and we won't get an expensive motor."
    },
    "171": {
        "startTime": 1504.23,
        "endTime": 1512.43,
        "transcript": "Taangamek-llu-gguq mer'atukumta akitulriamek aklumek aturngaunata",
        "translation": "And they said if we drink alcohol, we will not wear expensive clothes"
    },
    "172": {
        "startTime": 1512.78,
        "endTime": 1519.46,
        "transcript": "Akurarutekngamteki-gguq tamakut atu'urkamteńun navrucaryaaqelput.",
        "translation": "Becuase, they said, we squander what we would have traded for what we need."
    },
    "173": {
        "startTime": 1519.78,
        "endTime": 1528.28,
        "transcript": "Maa-i nutaan waten angukara'urluurcama tangvagaqa tamana qanruyutellerput.",
        "translation": "As I've become an old man like this, I'm seeing that traditional wisdom that was passed down to us."
    },
    "174": {
        "startTime": 1528.6,
        "endTime": 1534.12,
        "transcript": "Picimegcetun au͡gkut alerquagiyuitelliniut.",
        "translation": "People back then didn't give random instructions."
    },
    "175": {
        "startTime": 1534.55,
        "endTime": 1544.35,
        "transcript": "Atullmeggnek tau͡gaam ellaita alerquagitulliniut ciumteńi atullermeggnek.",
        "translation": "Instead, the give instruction on what they've experienced before us."
    },
    "176": {
        "startTime": 1544.99,
        "endTime": 1555.53,
        "transcript": "Iliini-ll' picurlallerteng aassaqevkenaku atuusqevkenaku inerquutaqluku picurlallerteng wangkutnun.",
        "translation": "And sometimes, they wouldn't hide their mistakes, and admonish us against committing their mistakes."
    },
    "177": {
        "startTime": 1585.46,
        "endTime": 1596.08,
        "transcript": "Qanruyuterugaita imkut qanrutestemta akuliitni piyulria qanruyutem tua-i ilakluku, ciknayaraq-gguq mana'.",
        "translation": "The many pieces of wisdom of our instructors, one among them would add this wisdom when they wanted to, what they call jealousy."
    },
    "178": {
        "startTime": 1596.35,
        "endTime": 1606.23,
        "transcript": "Yuk-gguq elluarrluni-llu yuungnaqura'urlulria ciknakluku imna angalkum ciknatarlim",
        "translation": "They said that a jealous shaman envies a person who is living and subsisting well"
    },
    "179": {
        "startTime": 1606.23,
        "endTime": 1615.31,
        "transcript": "Pinrillugcetaarluku picuirucetaqluku, wall' tukuuyulallrat man'a navgaqluku elluarrluteng yuuqataryaaqellrit.",
        "translation": "They curse them to be bad hunters, or break the wealth of those who were going to live well."
    },
    "180": {
        "startTime": 1615.31,
        "endTime": 1618.33,
        "transcript": "Umyuarrliqluteng tamakut cakneq.",
        "translation": "They have very malicious intentions."
    },
    "181": {
        "startTime": 1618.59,
        "endTime": 1625.54,
        "transcript": "Tua-i-llu cali qanruyutet makut:",
        "translation": "Then these other pieces of traditional wisdom:"
    },
    "182": {
        "startTime": 1625.54,
        "endTime": 1636.84,
        "transcript": "Ilameng-gguq akuliitni ik'ikengraitkut tua-i qessamkaukluta-ll' ayagyuarlurni maani",
        "translation": "They said that though those among us depreciate us, saying we young people here are lazy"
    },
    "183": {
        "startTime": 1636.84,
        "endTime": 1645.19,
        "transcript": "Unugmi-llu, aanairucarallruama-ll' wii unugmi-llu tan'geriaqan anenermek taq'laama",
        "translation": "And at night, since I stop going out at night when it gets dark because I lost my mother early"
    },
    "184": {
        "startTime": 1646.29,
        "endTime": 1654.15,
        "transcript": "Akeqnerrluggnauraatnga makut, qessamkaukuma tua-i waten kaigasteńguciqnilua.",
        "translation": "They would give me a harrowing promise, that if I'm lazy like this that I would be a beggar."
    },
    "185": {
        "startTime": 1654.85,
        "endTime": 1664.77,
        "transcript": "Picurlautek'larciqniluku-ll' tamana qessamkaulua pirraarlua ilanka uingequkata ayuqniam ugaani.",
        "translation": "They said that that would bring me misfortune if I'm lazy when those around me take husbands because I desire what they have so much."
    },
    "186": {
        "startTime": 1668.22,
        "endTime": 1674.48,
        "transcript": "Tau͡gaam tua-i tuaten qanrutaqluta makut wani qanenqegcaarautestemta.",
        "translation": "But our thorough instructors would tell us that."
    },
    "187": {
        "startTime": 1674.48,
        "endTime": 1687.57,
        "transcript": "Ilamta akuliitni-ll' ellalkartevkenata, imumek [?aapiir]tevkenata, murilkevlacagpek'nata, usviitevkenata ilamta akuliitni.",
        "translation": "Among those around us, we shouldn't act senselessly, [?], be unobservant, or be foolish among those around us."
    },
    "188": {
        "startTime": 1688.93,
        "endTime": 1693.3,
        "transcript": "Maktaqameng tua-i qanruqu'urnauraitkut",
        "translation": "When they got up, they'd always tell us"
    },
    "189": {
        "startTime": 1693.3,
        "endTime": 1696.71,
        "transcript": "\"Elpeci-ll' maa-i ayagyuani irniangekuvci-gguq",
        "translation": "\"When you young people also have children"
    },
    "190": {
        "startTime": 1696.71,
        "endTime": 1708.59,
        "transcript": "\"Irniarci-gguq mikelnguungalnge'rmi wall' pilukuvceńi camek inerququvciu, 'Kitak' at' ilaten piqaqatgen qimagaqluki [?ingluliuteng].'",
        "translation": "\"Though your child seems small, or if you admonish them when you put on their skin boots, 'If you peers do anything to you, run away [?and do not fight them].'"
    },
    "191": {
        "startTime": 1708.59,
        "endTime": 1710.52,
        "transcript": "\"Atam-gguq cumikeyagatuut.\"",
        "translation": "\"Watch, they pay attention.\""
    },
    "192": {
        "startTime": 1710.52,
        "endTime": 1720.33,
        "transcript": "Tua-i-gguq maa-i makut maa-i ciulirnemta makut tamana ellangeqarraallermeggni niitellerteng tua-i pikluku tua-i.",
        "translation": "They said that our elders keep what they've heard in their earliest memories."
    },
    "193": {
        "startTime": 1747.95,
        "endTime": 1756.16,
        "transcript": "Qanrutetullruitkut, yuungnaquralriit-gguq nulirqelriik Kass'artaitellrani imumi",
        "translation": "They would tell us that a married couple living on their own back when there was no Western contact"
    },
    "194": {
        "startTime": 1756.28,
        "endTime": 1761.74,
        "transcript": "Atiita ikamracualleraak makuk taqkunikek",
        "translation": "If their father finishes a sled"
    },
    "195": {
        "startTime": 1762.24,
        "endTime": 1771.28,
        "transcript": "Qanikciurun-llu muragaq taqkuniu, piqertuutacuar-llu qel'kekuniu, cikuliurun-llu",
        "translation": "And if he finishes the wooden sled, and keeps a small axe and ice pick"
    },
    "196": {
        "startTime": 1772.16,
        "endTime": 1781.82,
        "transcript": "Tua-i-gguq teguyarangqerciquq tauna family-t ata'urluat arrsaunge'rmi.",
        "translation": "They said they will have things at hand though the family's dear father is poor."
    },
    "197": {
        "startTime": 1782.02,
        "endTime": 1791.59,
        "transcript": "Neqkarcuun-llu-gguq qalu quarruugnek unangetuli qemangqakuniu",
        "translation": "And they said that if he keeps the fishing tool that catches sticklebacks"
    },
    "198": {
        "startTime": 1791.76,
        "endTime": 1798.03,
        "transcript": "Unarcianek-llu-gguq taluyitukuni neqkanek unangyugngalrianek",
        "translation": "And they said that if he makes fish traps that can catch fish out of straight grained pieces of wood"
    },
    "199": {
        "startTime": 1798.03,
        "endTime": 1805.63,
        "transcript": "Imarmiutarnek-llu unangyugngalrianek taluyaruanek-gguq civcitukuni",
        "translation": "And if he sets fish traps that can catch minks"
    },
    "200": {
        "startTime": 1806.15,
        "endTime": 1813.18,
        "transcript": "Arrsaunge'rmi-gguq tukurlirpagtun ayuqluni family-t atakekatni",
        "translation": "Though he's poor, if the family's father is like he's rich [in food and tools]"
    },
    "201": {
        "startTime": 1813.18,
        "endTime": 1823.12,
        "transcript": "Irniani cirivkarluki aturarrliqengraata aulukciqai pinirillrata yaavet engeliinun.",
        "translation": "He will take care of his children with abundance though they have tattered clothes all the way until they become strong."
    },
    "202": {
        "startTime": 1824.7,
        "endTime": 1830.75,
        "transcript": "Kass'artaitellrani makut maa-i qanruyutelput.",
        "translation": "This was the traditional wisdom passed down to us before Western contact."
    },
    "203": {
        "startTime": 1831.43,
        "endTime": 1839.72,
        "transcript": "Tangtullruunga-llu wangkuta tua-i arrsagni ayuqemteńek.",
        "translation": "I also used to see people like us who are poor."
    },
    "204": {
        "startTime": 1840.23,
        "endTime": 1852.17,
        "transcript": "Makut tang tua-i tan'gaurlurnek yulget carraquineq tau͡gaam iqluluteng arrsaunguaqatullinilriit.",
        "translation": "You see, only some who have male children falsly say that they are poor."
    },
    "205": {
        "startTime": 1853.33,
        "endTime": 1859.73,
        "transcript": "Qetunrateng makut pissuryaurtaqata, melqulegcuryaurtaqata",
        "translation": "When their sons start hunting fur-bearing animals"
    },
    "206": {
        "startTime": 1859.93,
        "endTime": 1868.02,
        "transcript": "Ata'urluat tuk'uqerrnaurtut patagmek tua-i melqulek akikeggillrani",
        "translation": "Their dear father would quickly get rich when fur was expensive."
    },
    "207": {
        "startTime": 1868.59,
        "endTime": 1873.96,
        "transcript": "Unaken call' unguvalrianek tua-i taguquringartaqameng",
        "translation": "Also, when they bring in animals from the [ocean] down there"
    },
    "208": {
        "startTime": 1874.17,
        "endTime": 1880.83,
        "transcript": "Arrsaucillrat imna nalluyagutnarqluni, ayuqnianarqaqluteng tua-i.",
        "translation": "We forget they'd been poor, and covet them."
    },
    "209": {
        "startTime": 1880.83,
        "endTime": 1889.73,
        "transcript": "Atameggnek aulukestekegciaqameng unakengait tamakut kiturcetevkenaki",
        "translation": "When their father takes good care of them by not letting what they obtained pass by"
    },
    "210": {
        "startTime": 1890.08,
        "endTime": 1895.42,
        "transcript": "Amlleriluki tau͡gaan tun'arkauluki piaq[ameng].",
        "translation": "Instead, giving them away when they've amassed."
    },
    "211": {
        "startTime": 1895.42,
        "endTime": 1906.38,
        "transcript": "Tuamtell' qanernaurtut, anngaqelriit-gguq ukut family-t waten ukut nukalpiat tallimauyaaqeciqut",
        "translation": "Then they'd say that there may be brothers in this family who are five great hunters"
    },
    "212": {
        "startTime": 1906.59,
        "endTime": 1913.98,
        "transcript": "Una-llu-gguq cali nulirqelriit atauciuyaaqeciquq qetunraak.",
        "translation": "And they said a married couple may have one son."
    },
    "213": {
        "startTime": 1914.31,
        "endTime": 1921.99,
        "transcript": "Uum-gguq qetunraagnek taukut ayuqniarluki anngaqelriit talliman nukalpiat.",
        "translation": "They said that their son here wants to be like the great hunter brothers."
    },
    "214": {
        "startTime": 1922.25,
        "endTime": 1929.42,
        "transcript": "Qessalertevenani nalluatgun inglukluki pingnatukuni",
        "translation": "If he's not lazy and competes with them without their knowledge when hunting"
    },
    "215": {
        "startTime": 1929.72,
        "endTime": 1935.61,
        "transcript": "Ukut-gguq pitacirciqai talliman nukalpiat.",
        "translation": "They said he would get as much as these five great hunters."
    },
    "216": {
        "startTime": 1935.61,
        "endTime": 1941.76,
        "transcript": "Talliman-gguq nukalpiat nalluatni ingluklerkaat qacignarquq.",
        "translation": "They said it's easy to compete with great hunters without their knowledge."
    },
    "217": {
        "startTime": 1941.76,
        "endTime": 1946.21,
        "transcript": "Nuvkutaagutetuut-gguq ukut anngaqellriit.",
        "translation": "They said that these brothers argue."
    },
    "218": {
        "startTime": 1946.21,
        "endTime": 1954.79,
        "transcript": "\"Pi-gguq kuvyayaqili; wii kuvyayaryuumiitua.\" \"Pi-gguq muragcuqili; wii muragcuryuumiitua.\"",
        "translation": "\"Tell him to drift net; I don't want to drift ent.\" \"Tell him to gather wood; I don't want to gather wood.\""
    },
    "219": {
        "startTime": 1954.79,
        "endTime": 1959.99,
        "transcript": "Maa-i-gguq makut qacignarqutiit ayagnerat iqua.",
        "translation": "They said this is what it means when it's easy to begin [competing with them]."
    },
    "220": {
        "startTime": 1959.99,
        "endTime": 1965.6,
        "transcript": "Uum-gguq atauciunge'rmi ayuqeliyugngai ingluliluki.",
        "translation": "They said that even this one person can be like them."
    },
    "221": {
        "startTime": 1965.6,
        "endTime": 1973.39,
        "transcript": "Makut maa-i qanruqurauteput ellangyugallemteńi Kass'anek makunek piitellermeggni.",
        "translation": "These are the things they told us in our early memories before Western contact."
    },
    "222": {
        "startTime": 1998.51,
        "endTime": 2011.41,
        "transcript": "Neviarcaraat-llu makut uingeksailnguut angliyartullrat maliggluku ayuqucirtuutnek nutaan patutullruit inerquutnek.",
        "translation": "And following the growth of these unmarried young ladies, they would cover them with instructions and admonishments."
    },
    "223": {
        "startTime": 2012.08,
        "endTime": 2023.77,
        "transcript": "Agurrluk'-llu yuut tangvanrilkiitni nukalpianun unugmi narukitautesqevkenaki inerquraqluki.",
        "translation": "And they would admonish them against ever going to meet a young man at night when people aren't watching."
    },
    "224": {
        "startTime": 2024.26,
        "endTime": 2033.68,
        "transcript": "Wangkuta-llu unugmi neviarcaraat akuliitni narukitautesqevkenata.",
        "translation": "They also told us not to meet with young ladies at night."
    },
    "225": {
        "startTime": 2035.06,
        "endTime": 2047.47,
        "transcript": "Alegyagulluku-gguq nasaurluq yugnek tangvagtaitnitekluta kemga agtuqumteggu wangkutnek-gguq tuquciiqukut.",
        "translation": "They said that if we're confident in touching a girl's flesh because people aren't watching, we'll kill ourselves."
    },
    "226": {
        "startTime": 2047.47,
        "endTime": 2050.73,
        "transcript": "Nulirruarluta tua-i.",
        "translation": "We pretend to have a wife."
    },
    "227": {
        "startTime": 2050.85,
        "endTime": 2055.5,
        "transcript": "Tamaa-i atam alingnarcarluku qanrutkaat.",
        "translation": "You see, they would speak of that to make it scary."
    },
    "228": {
        "startTime": 2055.58,
        "endTime": 2060.1,
        "transcript": "Arnat-llu makut enemi agleraqata qanrutnaurait",
        "translation": "And when these women menstruate at home, they'd tell them"
    },
    "229": {
        "startTime": 2060.1,
        "endTime": 2064.35,
        "transcript": "\"Kitak' wak'nirnek ayagluten tua-i eglertuten.",
        "translation": "\"Now, from here on out, you go forth."
    },
    "230": {
        "startTime": 2064.46,
        "endTime": 2074.21,
        "transcript": "\"Nulirtuqsailnguq yun'erra'ar tan'gaurluq anuqiin asguakun agurrluk' kituryaqunaku, avaggun tau͡gaam uqrakun.",
        "translation": "\"Never pass an unmarried young man, a boy, upwind from him, but over there downwind from him."
    },
    "231": {
        "startTime": 2074.21,
        "endTime": 2084.61,
        "transcript": "\"Tepen-gguq atam narluku narumangniariaa. Assiiruyutekaa-gguq kiituan.\"",
        "translation": "\"When he smells your emanations, he will keep smelling it. Eventually, it ruins him.\""
    },
    "232": {
        "startTime": 2085.12,
        "endTime": 2088.61,
        "transcript": "Tuaten-qaa qanrucuitellruatgen?",
        "translation": "Wouldn't they tell you that?"
    },
    "233": {
        "startTime": 2088.67,
        "endTime": 2090.51,
        "transcript": "Qanrutaqluta.",
        "translation": "They would tell us."
    },
    "234": {
        "startTime": 2090.51,
        "endTime": 2092.18,
        "transcript": "Au͡gna-q' elitaqenritan?",
        "translation": "Don't you recognize that?"
    },
    "235": {
        "startTime": 2092.18,
        "endTime": 2095.37,
        "transcript": "Qang'a, elitaqkacagarluku.",
        "translation": "No, I completely recognize it."
    },
    "236": {
        "startTime": 2095.37,
        "endTime": 2098.07,
        "transcript": "Tepii-gguq narluku.",
        "translation": "They say he smells her emanations."
    },
    "237": {
        "startTime": 2122.86,
        "endTime": 2131.46,
        "transcript": "Aipaput kenekluki pisqessaaqaqluki, uiput cumikluki",
        "translation": "They'd tell us to love our spouses, to attend to our husbands"
    },
    "238": {
        "startTime": 2131.46,
        "endTime": 2133.61,
        "transcript": "Allaliuqsaunata-llu.",
        "translation": "And never be unfaithful."
    },
    "239": {
        "startTime": 2133.61,
        "endTime": 2141.56,
        "transcript": "Uimta-llu nalluatni arnaurlulriani wangkuta ayagallerkartuyarrluta",
        "translation": "And if we women start going out without our husbands' knowledge"
    },
    "240": {
        "startTime": 2141.56,
        "endTime": 2146.85,
        "transcript": "Kiituani-gguq taum uimta pikenrilkiinek qingangaqluta-gguq.",
        "translation": "They said we'd eventually be pregnant from someone other than our husband."
    },
    "241": {
        "startTime": 2146.85,
        "endTime": 2158.0,
        "transcript": "Imkut maaten tamaani ellangeqarrallamteńi qanrutaqamegtegkut ikiu͡k'acagarluku ca ikuggluku qanrutnauraitkut.",
        "translation": "When they instructed us in our earliest memories, we found that they would pry out extremeply improper things as they spoke to us."
    },
    "242": {
        "startTime": 2158.0,
        "endTime": 2164.2,
        "transcript": "Tangvagluta-ll' piaqatkut, waten umyuarteqsaaqnaurtukut wangkuta niicugnilriani:",
        "translation": "And when they'd watch us, we who are listening would think like this:"
    },
    "243": {
        "startTime": 2164.2,
        "endTime": 2169.72,
        "transcript": "\"Aling ik'um-am cunaw' nallunrilkiikut, tangellrukiikut.\"",
        "translation": "\"Wow, that one across there apparently knows us, has seen us.\""
    },
    "244": {
        "startTime": 2169.72,
        "endTime": 2175.09,
        "transcript": "Tuar tang nallunritkacagarluta ilumun tangellruluta pilaqaitkut.",
        "translation": "They spoke to us as if they completely knew us, as if they truly had seen us."
    },
    "245": {
        "startTime": 2175.88,
        "endTime": 2182.36,
        "transcript": "Cunaw' tamakut qanruciyupialriit ircaqurteng cairluku ellaita atullmeggnek.",
        "translation": "It turned out that those who wished to speak would cleanse their hearts of their experiences."
    },
    "246": {
        "startTime": 2182.36,
        "endTime": 2188.53,
        "transcript": "Assirluki yuk agesqelluku qanruturlularyaaqellinikaitkut.",
        "translation": "The dear ones would speak to us so that a person would go [through life] well."
    },
    "247": {
        "startTime": 2188.53,
        "endTime": 2193.18,
        "transcript": "Irniau͡rluput-llu waten makut irniaqsagutaqamteki",
        "translation": "And when we have these dear children"
    },
    "248": {
        "startTime": 2193.18,
        "endTime": 2200.61,
        "transcript": "Agurrluk' tua-i agutevkenaki, tass'uqluki-ll' enenun allanun ceńirtaaruqu'urtev[kenaki].",
        "translation": "They told us to never bring them, and not to hold their hands to have them visit other houses."
    },
    "249": {
        "startTime": 2200.61,
        "endTime": 2203.0,
        "transcript": "Atam-gguq asriurturlurniartut.",
        "translation": "They said they'd become mischievous."
    },
    "250": {
        "startTime": 2203.0,
        "endTime": 2211.11,
        "transcript": "Ikiurlullrat man'a arrasaurlullerput ilalqerluku-gguq atam aanaulriami wani enem nayurtiini.",
        "translation": "They said their misbehavior would exacerbate our destitution for the mother who stays with them at home."
    },
    "251": {
        "startTime": 2211.11,
        "endTime": 2216.21,
        "transcript": "Una-wa-gguq aatavut ayagalria pikangengnaqluta.",
        "translation": "Our father travels to try to subsist for us."
    },
    "252": {
        "startTime": 2216.21,
        "endTime": 2223.85,
        "transcript": "Pitarra'urlui-gguq tekitaqan quyatekluki ciuniurluki arnaulriani.",
        "translation": "They said we women should be thankful for whatever he catches and welcome them."
    },
    "253": {
        "startTime": 2224.2,
        "endTime": 2233.83,
        "transcript": "Wall' akirrarmek unangekan qenngevkenata wangkuta arnani taqmaqegciyugluta, wall' camek cap'akiqegciyugluta",
        "translation": "Or if he gets a little money, we woman should not be angry wanting a beautiful dress, or some beautiful shoes"
    },
    "254": {
        "startTime": 2233.83,
        "endTime": 2239.65,
        "transcript": "Aturaqegciamta-gguq tua-i pikarciaritnek maa-i nangerngiimta.",
        "translation": "Because they said we're standing here with wonderful clothes they've gotten us."
    },
    "255": {
        "startTime": 2239.65,
        "endTime": 2246.48,
        "transcript": "Tamakut-gguq navguutekai taum aipamteńun.",
        "translation": "They said those are detrimental for our spouses."
    },
    "256": {
        "startTime": 2246.48,
        "endTime": 2253.07,
        "transcript": "Tamakut unangkengarait, uiu͡rlumta unangkengarait munarulluki.",
        "translation": "Those things they obtain, we should work skillfully with what our spouses obtain."
    },
    "257": {
        "startTime": 2253.07,
        "endTime": 2256.9,
        "transcript": "Munarcallrani tauna aipa'urluput ukisqirluki.",
        "translation": "As our dear spouses work dextrously, help them."
    },
    "258": {
        "startTime": 2256.9,
        "endTime": 2264.22,
        "transcript": "Tamakut tamaa-i anglanitekevkenaki-gguq, akingutaurlui tegulerulluta ayagpek'nata.",
        "translation": "They said we shouldn't squander those things, taking his money and going."
    },
    "259": {
        "startTime": 2264.22,
        "endTime": 2271.42,
        "transcript": "Avani-ll' ayanantemteńi canun akusrarrnarqelrianun tekiskumta, wall' mer'aluta, wall' canun",
        "translation": "And as we go, when we come across socially inappropriate things, or drink, or something"
    },
    "260": {
        "startTime": 2271.7,
        "endTime": 2276.35,
        "transcript": "Inerqurluta tua-i tamalkuita tamakunek aarnarqelrianek.",
        "translation": "They'd admonish us against all of those dangerous things."
    },
    "261": {
        "startTime": 2276.35,
        "endTime": 2282.65,
        "transcript": "Irniamta-ll' takuatni tuaten ayuqesqevkenata. Alerquaciqaput-gguq.",
        "translation": "And they told us not to be like that in front of our children. They said we'd teach them."
    },
    "262": {
        "startTime": 2306.52,
        "endTime": 2315.21,
        "transcript": "Tua-i tuaten tau͡gaam ilalqerpek'nani yuk yuurluqili mat'um nalliini.",
        "translation": "May a person live without exacerbating [problems] like that these days."
    },
    "263": {
        "startTime": 2315.21,
        "endTime": 2318.89,
        "transcript": "Tamana-llu tamaa-i akerrneqluggutek'lallrat",
        "translation": "That was their harrowing promise"
    },
    "264": {
        "startTime": 2318.89,
        "endTime": 2326.62,
        "transcript": "Akusrangkumta-gguq tamakut angayuqamta qanrutestemta, ciulirnemta qanrutaqamegtekut",
        "translation": "They said if we misbehave when our parents who instruct us, and our elders instruct us"
    },
    "265": {
        "startTime": 2326.62,
        "endTime": 2331.03,
        "transcript": "Akusrangkumta-gguq camek elpek['ngaarulluta].",
        "translation": "They said if we we misbehave, we'll become insensitive."
    },
    "266": {
        "startTime": 2331.03,
        "endTime": 2340.95,
        "transcript": "Qanrutestevut cumikenrirluku, alerquastevut elluarrluta yuusqelluta, aviranaunata ilamta akuliitni.",
        "translation": "We stop paying attention to our teachers, our instrcuts, who tell us to live well, not to hinder those around us."
    },
    "267": {
        "startTime": 2340.95,
        "endTime": 2346.02,
        "transcript": "Tau͡gaam-gguq assirluta tangniqluta enemteńi aqumluta",
        "translation": "Instead, they said we should be good and look nice sitting at home"
    },
    "268": {
        "startTime": 2346.02,
        "endTime": 2350.75,
        "transcript": "Enevut-gguq uitaqegcinaqniartuq.",
        "translation": "So, they said, our house will be nice to be in."
    },
    "269": {
        "startTime": 2350.75,
        "endTime": 2356.79,
        "transcript": "Allaneruaraam-llu nanikualuni itervikekakut uitanqegcivkangnaqluku",
        "translation": "And if a helpless guest comes in our house, try to make them feel at home"
    },
    "270": {
        "startTime": 2356.79,
        "endTime": 2360.86,
        "transcript": "Imuuvkenata, akusrartevkenata yuukumta.",
        "translation": "If we live without, you know, being mischievous."
    },
    "271": {
        "startTime": 2360.86,
        "endTime": 2372.05,
        "transcript": "Tua-i tuaten qanraqata piyugyaaqengramta, amta-llu tua-i iliini canun tekitengaqluta tua-i.",
        "translation": "When they said that, though we wanted to, yet we would sometimes come upon things."
    },
    "272": {
        "startTime": 2372.37,
        "endTime": 2376.65,
        "transcript": "Assiryugyaaqellerput man'a ukatairuluku.",
        "translation": "We do not fulfill our desire to do well."
    },
    "273": {
        "startTime": 2376.65,
        "endTime": 2384.25,
        "transcript": "Ayagyuarluta-ll' qingircetlerkaq tua-i alingnaqkacagarluni, mikelngurmek alairillermek.",
        "translation": "And it would very scary to be impregnated at a young age, to bring forth a child."
    },
    "274": {
        "startTime": 2384.25,
        "endTime": 2387.52,
        "transcript": "Aatailnguut tallurnaqkacagarluteng-gguq.",
        "translation": "They said illegitimate children were very embarrassing."
    },
    "275": {
        "startTime": 2387.52,
        "endTime": 2389.79,
        "transcript": "Inerquutngullruyaaqluni.",
        "translation": "It was an admonishment."
    },
    "276": {
        "startTime": 2389.79,
        "endTime": 2396.05,
        "transcript": "Maa-i tamatuullinill' akusrangllerkaatnek qanlallrat imkut au͡gkut ciuliamta.",
        "translation": "This is the misbehavior that our elders back then spoke of."
    },
    "277": {
        "startTime": 2396.05,
        "endTime": 2404.81,
        "transcript": "Inerquutet makut wani assiitellriit atuqsaileng'erpeciki ayagyuani.",
        "translation": "You young people shouldn't do these bad things that are admonished against."
    },
    "278": {
        "startTime": 2405.93,
        "endTime": 2409.73,
        "transcript": "Maligqurassiyaagpegnaki Kass'at makut pisqutait.",
        "translation": "Do not follow these Western ways too much."
    },
    "279": {
        "startTime": 2409.73,
        "endTime": 2417.76,
        "transcript": "Canek tua-i makut puyurtull'e'rnek-llu canek pilarniitki iqugglugningqeńilaitki tamakut",
        "translation": "And since they speak of marijuana, that it has negative effects"
    },
    "280": {
        "startTime": 2417.76,
        "endTime": 2419.65,
        "transcript": "Tamakut atuqsailengraata.",
        "translation": "Don't use those."
    },
    "281": {
        "startTime": 2419.65,
        "endTime": 2422.98,
        "transcript": "Waten tau͡gaam yuuqallerput tang tua-i ikgetlinilria.",
        "translation": "You see, we only have a short life like this."
    },
    "282": {
        "startTime": 2422.98,
        "endTime": 2432.97,
        "transcript": "Una wani ayagyuallerput ellangellerput canimelngat'laryaaqell', amta-ll' [?] waten pinialiluta carpagciigaliluta.",
        "translation": "Though our youth and earliest memories seems close, yet we weaken like this and can't do anything strenuous."
    },
    "283": {
        "startTime": 2432.97,
        "endTime": 2440.03,
        "transcript": "Taumek mulngakluci tuaten tamakut assiiterrlainaat maligtevkenaki.",
        "translation": "That's what you should be careful like that, not only following those bad things."
    },
    "284": {
        "startTime": 2440.03,
        "endTime": 2448.77,
        "transcript": "Cavvliurluci, yuungnaqluci, akingengnaqluci pikuvci tengruluci quyanarqeqacaarciquci.",
        "translation": "If you are buy, subsist, and try to earn money with fervor, we will be thankful for you."
    },
    "285": {
        "startTime": 2448.77,
        "endTime": 2456.82,
        "transcript": "Akinguteci tau͡gaam tuaten elpeceńun, enevceńun-llu aturluki ikayuutekluki, aklukluki.",
        "translation": "Instead, use the money you earn for yourselves, your houses, use them for help, and for clothes."
    },
    "286": {
        "startTime": 2457.11,
        "endTime": 2467.46,
        "transcript": "Wiinga-ll' tua-i waniwa qitevvneq-llu nalluamku qaill' ucuryagutekevkenaku atuyuilamku tua-i.",
        "translation": "And since I don't know how to speak English, I am not in awe of it in any way because I don't use it."
    },
    "287": {
        "startTime": 2468.08,
        "endTime": 2475.61,
        "transcript": "Pisqeqapigtaqatnga tau͡gaam ik'um-ll' aiparma maliklua camek, maligglua camek tua-i tegutaqlua",
        "translation": "Only when they really want me to, and when my spouse across there goes with me, I take something"
    },
    "288": {
        "startTime": 2475.61,
        "endTime": 2479.71,
        "transcript": "Una-kiq qaill' tunllerkaa nalluk'acagaamku.",
        "translation": "Because I have no idea how to give out this [money]."
    },
    "289": {
        "startTime": 2479.71,
        "endTime": 2486.4,
        "transcript": "Quyanaqkacagarluni. Tua-i quyaaqlua nallucimnek uitanqegcilua uitalaama.",
        "translation": "I'm very thankful. I'm thankful that I don't know because I stay peacefully."
    },
    "290": {
        "startTime": 2509.51,
        "endTime": 2517.63,
        "transcript": "Man'a taangaq elpecinun assinritqapiareyaaquq atungnaqellra.",
        "translation": "It's not good for you to abuse this alcohol."
    },
    "291": {
        "startTime": 2517.63,
        "endTime": 2526.27,
        "transcript": "Tau͡gaam taangaq man'a trouble-aamun tau͡gaam pinaqluni.",
        "translation": "Instead, this alcohol only leads to trouble."
    },
    "292": {
        "startTime": 2526.27,
        "endTime": 2535.49,
        "transcript": "Cali yuk taangarpakarluni iqlutmun piarkaqenrilkeńi tekilluku ellmineng picurlatuuq.",
        "translation": "Also, when a person drinks too much, they go the wrong way and bring themselves to misfortune."
    },
    "293": {
        "startTime": 2535.57,
        "endTime": 2539.26,
        "transcript": "Cali man'a meluk aipaa...",
        "translation": "The other one also, smoking..."
    },
    "294": {
        "startTime": 2540.74,
        "endTime": 2542.21,
        "transcript": "Patuu.",
        "translation": "Close it."
    },
    "295": {
        "startTime": 2542.21,
        "endTime": 2553.59,
        "transcript": "Aipaa tamana meluk man'a umyugamun tau͡gaam ayatulria, man'a-llu tema tapulluku.",
        "translation": "That other one, smoking, only goes to the mind, along with this body."
    },
    "296": {
        "startTime": 2553.59,
        "endTime": 2563.82,
        "transcript": "Wii atuyuicaaqaqa qaillun ayuqellra, tau͡gaam niitetuama wanigga tamatumeng melugmeng ayuqucianeng",
        "translation": "I don't use it [or know] what it's like, but because I hear about what that smoking is like"
    },
    "297": {
        "startTime": 2563.82,
        "endTime": 2568.16,
        "transcript": "Umyugaq tau͡gaam nagvutuniluku.",
        "translation": "That it only destroys the mind."
    },
    "298": {
        "startTime": 2568.16,
        "endTime": 2573.82,
        "transcript": "Cali qavarturangluni tauna melugpakatuli.",
        "translation": "Also, that one who smokes too much starts sleeping all the time."
    },
    "299": {
        "startTime": 2573.82,
        "endTime": 2579.04,
        "transcript": "Tau͡gaten niitetuunga tamatumeng melugaqata.",
        "translation": "That's what I hear when they smoke that."
    },
    "300": {
        "startTime": 2579.04,
        "endTime": 2585.17,
        "transcript": "Ilumuuluni tamana pituyugnarquq.",
        "translation": "I think that truly does happen."
    },
    "301": {
        "startTime": 2585.17,
        "endTime": 2589.15,
        "transcript": "Melugpakalria man'a qavarturangluni.",
        "translation": "One who smokes too much sleeps all the time."
    },
    "302": {
        "startTime": 2589.15,
        "endTime": 2594.0,
        "transcript": "Cali unim[yugluteng], you know?",
        "translation": "[They] also [become] forgetful, you know?"
    },
    "303": {
        "startTime": 2594.14,
        "endTime": 2601.46,
        "transcript": "They forgot what to do. Ellirraarluki-llu cat wanirpaagaq nalluyagutaqluki.",
        "translation": "They forgot what to do. And after they put something down, they immediately forget them."
    },
    "304": {
        "startTime": 2601.46,
        "endTime": 2608.13,
        "transcript": "Wii qetunrama iliit tau͡gaten, iliit, inerqungramteng",
        "translation": "One of my sons like that, though I admonish them"
    },
    "305": {
        "startTime": 2608.38,
        "endTime": 2612.28,
        "transcript": "Tamatumeng iliini atuqeryutuata",
        "translation": "Since they sometimes use that"
    },
    "306": {
        "startTime": 2612.28,
        "endTime": 2616.6,
        "transcript": "Nunutuyaaqanka cakneq wii pirramneng.",
        "translation": "I harshly scold them to the best of my ability."
    },
    "307": {
        "startTime": 2640.91,
        "endTime": 2648.74,
        "transcript": "Wangkutnek-wa tua-i wangni, naliata akwaugaq qanrutaanga, [?Ayapqu]gcaram piyugnarqaanga",
        "translation": "From us, one of them told me yesterday, I think it was [?Ayapqu]gcaraq"
    },
    "308": {
        "startTime": 2649.06,
        "endTime": 2661.73,
        "transcript": "Wangkutnek wii nallemnek tuar tang ayagluta wangkutnek man'a yuum ayallra cimilria.",
        "translation": "From us, it seems that starting from my time, the way a person goes [through life] has changed."
    },
    "309": {
        "startTime": 2662.57,
        "endTime": 2664.13,
        "transcript": "Qaa?",
        "translation": "Right?"
    },
    "310": {
        "startTime": 2664.82,
        "endTime": 2669.09,
        "transcript": "Kass'atun makut kinguqliput ellirtut.",
        "translation": "Our descendants have become Westernized."
    },
    "311": {
        "startTime": 2670.07,
        "endTime": 2675.77,
        "transcript": "Kass'arngariut, ilait-llu Yugtun taringesciigaliluteng.",
        "translation": "They've become Westernized, and some can't understand Yup'ik anymore."
    },
    "312": {
        "startTime": 2676.89,
        "endTime": 2680.55,
        "transcript": "Kass'aturrlainaq tau͡gaam qalarqurangluteng.",
        "translation": "Instead, they've started speaking only in English."
    },
    "313": {
        "startTime": 2681.22,
        "endTime": 2688.71,
        "transcript": "Tua-ll' waniw' Yugtun yuullerkam ayuqucianek piyaaqengramta",
        "translation": "And now, though we speak about how a Yup'ik life should go"
    },
    "314": {
        "startTime": 2688.71,
        "endTime": 2694.94,
        "transcript": "Makut tamakut Kass'atun elitellriit qaillun elitnauqatarceta?",
        "translation": "How will we teach those who've learned English?"
    },
    "315": {
        "startTime": 2695.96,
        "endTime": 2705.4,
        "transcript": "Ataam-qaa au͡gna yuuqtallerput tengruluteng ataam ayagniryugngaciqaat?",
        "translation": "Will they be able to enthusiastically start our old way of life again?"
    },
    "316": {
        "startTime": 2706.44,
        "endTime": 2710.11,
        "transcript": "Caknerluta wangkuta yuullerput.",
        "translation": "Our lives where we struggled."
    },
    "317": {
        "startTime": 2710.43,
        "endTime": 2717.07,
        "transcript": "Qimugtetgun-llu ayagaluta, kayimngina'arturluta-llu qugtatullruluta Akulmi.",
        "translation": "And we'd travel by dog sled, and gather wood in the Akula region by pushing our sleds without dogs."
    },
    "318": {
        "startTime": 2717.19,
        "endTime": 2720.87,
        "transcript": "Qimugtaunata-llu ayagatullruluta.",
        "translation": "And we used to travel without dogs."
    },
    "319": {
        "startTime": 2720.87,
        "endTime": 2731.55,
        "transcript": "Qanikciurutput-llu elluatuullruvkenateng, piqertuutaput-llu elluatuullruvkenateng wangkuta ciuqlirpeceńi.",
        "translation": "And our shovels were not sophisticated, and our axes were not sophisticated, we who came before you."
    },
    "320": {
        "startTime": 2731.55,
        "endTime": 2739.38,
        "transcript": "Makut tua-llu-w' nutaan ciuqliput nutaan tangrruarqamteng nutaan caknepiallruyugnarqut.",
        "translation": "Now, especially when I imagine our elders, they probably struggled even more."
    },
    "321": {
        "startTime": 2739.38,
        "endTime": 2748.78,
        "transcript": "Ukatmun Kass'at tungiitnun calissuutait call' tungiitnun ayallerput maliggluku tuarpiaq qacignariinarluteng cat.",
        "translation": "As we went to becoming Westernised along with their tools, it truly seems that things have become easier."
    },
    "322": {
        "startTime": 2748.78,
        "endTime": 2753.71,
        "transcript": "Waniwa-ll' yaaqsingraan wanirpaagaq tekiarcaurrluku",
        "translation": "And now, though a place is far, we've started reaching it right away"
    },
    "323": {
        "startTime": 2753.71,
        "endTime": 2758.84,
        "transcript": "Wangkuta unuakuyaarmek ayagluta caqtarturatullerput.",
        "translation": "The place we'd steadily start going to from the early morning."
    },
    "324": {
        "startTime": 2759.24,
        "endTime": 2760.99,
        "transcript": "Tua-llu?",
        "translation": "You understand?"
    },
    "325": {
        "startTime": 2787.46,
        "endTime": 2795.34,
        "transcript": "Makut qanruyutait ciuliamta wangkuta qemagngangaicaaqaput elisngastaitni",
        "translation": "We who are knowledgeable about our ancestors' wisdom will not keep them to ourselves"
    },
    "326": {
        "startTime": 2795.34,
        "endTime": 2801.03,
        "transcript": "Akaarnun nunami maani nangengqatnguata.",
        "translation": "Because they help us to stand on this earth for a long time."
    },
    "327": {
        "startTime": 2801.38,
        "endTime": 2806.74,
        "transcript": "Kenkek'ngaput-qaa tuquyararaasqaput wangkuta yup'ut?",
        "translation": "Do we wish an early death on our children whom we love?"
    },
    "328": {
        "startTime": 2806.74,
        "endTime": 2814.1,
        "transcript": "Kenkekumteki makunek ciuliamta alerquutaitnek arcaqerluki qanrutarkaugaput.",
        "translation": "If we love them, we must especially tell them about our ancestors' traditional instructions."
    },
    "329": {
        "startTime": 2814.1,
        "endTime": 2824.86,
        "transcript": "Tuamta-llu wangkuta Yugni alerquutengqertukut yuullgutput tamalkuita elluarrluki ciuniuresqelluki",
        "translation": "Then, we Yupiit are instructed to welcome all of our fellow people well"
    },
    "330": {
        "startTime": 2824.86,
        "endTime": 2828.67,
        "transcript": "Allakaukevkenaki, ilakuyulluta.",
        "translation": "Without discrimination, but as a whole."
    },
    "331": {
        "startTime": 2828.67,
        "endTime": 2838.92,
        "transcript": "Kitumek kinkut imkut Alaska-m yui tuaten umyuallgutekluteng ilakuyulluki nangengqasqumaut.",
        "translation": "No matter who they are, the people of Alaska are asked to stand together with one mind."
    },
    "332": {
        "startTime": 2838.92,
        "endTime": 2847.35,
        "transcript": "Mat'um ilii, mat'um-am agayumacim ilait waten qanertut:",
        "translation": "Part of these, some of these religions say this:"
    },
    "333": {
        "startTime": 2847.35,
        "endTime": 2852.11,
        "transcript": "\"Wangkuta agayumacirput assirtuq tukniluni-llu.\"",
        "translation": "\"Our religion is good and powerful.\""
    },
    "334": {
        "startTime": 2852.11,
        "endTime": 2856.74,
        "transcript": "Tuaten pinrituq. Tuaten ayuqenrituq.",
        "translation": "That's not the case. That's not what it's like."
    },
    "335": {
        "startTime": 2856.74,
        "endTime": 2864.42,
        "transcript": "Ciuliamta ilakuyutiit navyunaicaaqerput wangkuta, piunriyunaunaku-llu.",
        "translation": "We should not destroy our ancestors' community mindset, or abolish it."
    },
    "336": {
        "startTime": 2864.42,
        "endTime": 2872.35,
        "transcript": "Una ilakuyun avaken ayagluni ciuliamta qanrutkaat kenkauguq.",
        "translation": "This community mindset, our ancestors have said since long ago that it's a form of love."
    },
    "337": {
        "startTime": 2872.35,
        "endTime": 2879.32,
        "transcript": "Kenka atunrilkumteggu maani unguvallemteńi qaill' piluta anirtuumaciqceta?",
        "translation": "If we don't practice love as we live here, how will we be saved?"
    },
    "338": {
        "startTime": 2879.32,
        "endTime": 2881.77,
        "transcript": "Allamek anirtuutaitukut.",
        "translation": "We have no other salvation."
    },
    "339": {
        "startTime": 2881.77,
        "endTime": 2884.89,
        "transcript": "Ciuliamta kenka atullruat.",
        "translation": "Our ancestors practiced love."
    },
    "340": {
        "startTime": 2884.89,
        "endTime": 2894.39,
        "transcript": "Anirtuumaluteng-llu ayaumaluteng tamana atullruamegteggu yuullgutmeggnun tamalkuitnun allakaukutevkenateng.",
        "translation": "And they were saved as they went because they practiced that to all of their fellow people without discrimination."
    },
    "341": {
        "startTime": 2894.39,
        "endTime": 2904.78,
        "transcript": "Agayumacit ayuqenrilnguut allakaukucetaangraatkut, tamana allakaukucaraq assiituq uitacurlagnaqluni-llu.",
        "translation": "Though various religions try to divide us, that division is not good and leads to unrest."
    },
    "342": {
        "startTime": 2904.78,
        "endTime": 2913.86,
        "transcript": "Ciuliamta tau͡gaam alerquutiit ilakuyucaraq atuqumteggu nutaan uitanqegciluta nangengqaciqukut",
        "translation": "Only if we practice our ancestors' community lifestyle will we stand peacefully"
    },
    "343": {
        "startTime": 2913.86,
        "endTime": 2917.32,
        "transcript": "Ukverput-llu qaqimalriaruluni.",
        "translation": "And our faith will be complete."
    },
    "344": {
        "startTime": 2942.18,
        "endTime": 2953.0,
        "transcript": "Nunam yuini wangkuta mat'umek ak'allarpall'e'rmek ayuqucirtuutmek teggutengqertukut tua-i taumek.",
        "translation": "We people of the earth have a solid foundation with this ancient traditional instruction."
    },
    "345": {
        "startTime": 2953.35,
        "endTime": 2961.23,
        "transcript": "Man'a-llu teggutvut takarnaqpiarluni, takarnairucuunani-llu.",
        "translation": "And our solid foundation here is worthy of great respect, and will not lose that."
    },
    "346": {
        "startTime": 2961.23,
        "endTime": 2971.06,
        "transcript": "Makuni maa-i watua tegganeruaramteńi makuni",
        "translation": "Here, in what elders we have today"
    },
    "347": {
        "startTime": 2971.06,
        "endTime": 2975.6,
        "transcript": "Tamatumi takarnarquciq uitauq.",
        "translation": "That is where the cause for respect is."
    },
    "348": {
        "startTime": 2976.58,
        "endTime": 2989.22,
        "transcript": "Takarnarqelriim cam imum tamatum nunam yui tamakut tegguciumaluki.",
        "translation": "What is worthy of respect gives a solid foundation for the people of the earth."
    },
    "349": {
        "startTime": 2989.22,
        "endTime": 2995.03,
        "transcript": "Tauna-llu tegguciumasteseng ellaita nalluvkenaku.",
        "translation": "And they know the one that gives them their solid foundation."
    },
    "350": {
        "startTime": 2995.03,
        "endTime": 3002.96,
        "transcript": "Taumek man'a ak'allaq ukanirpak tailria teggutekngamteggu",
        "translation": "Since this ancient thing that's come from long ago is our solid foundation"
    },
    "351": {
        "startTime": 3002.96,
        "endTime": 3011.27,
        "transcript": "Tua-i nangerngatekluku-llu calritara'urlulriani maani nangerngaurlurtukut.",
        "translation": "And since it's our support for life, we who are healthy are standing here."
    },
    "352": {
        "startTime": 3011.78,
        "endTime": 3017.55,
        "transcript": "Man'a-llu waten ayuqucirput:",
        "translation": "And this is what we're like:"
    },
    "353": {
        "startTime": 3017.55,
        "endTime": 3026.15,
        "transcript": "Yuum taum atra, Yugtun atra tua-i pirkaparput.",
        "translation": "We value a person's name, their Yup'ik name."
    },
    "354": {
        "startTime": 3026.89,
        "endTime": 3035.38,
        "transcript": "Cali-llu Yugtun qanerturalleq cali una pirpakarput Yuungamta tua-i.",
        "translation": "We also value speaking in Yup'ik because we're Yup'ik."
    },
    "355": {
        "startTime": 3035.38,
        "endTime": 3044.37,
        "transcript": "Tauna arcaqerluku akulemteńi aterpagtaarturaulluta quyanaqpiartuq.",
        "translation": "That especially, calling each other by our [Yup'ik] names, is a cause for great thanks."
    },
    "356": {
        "startTime": 3044.49,
        "endTime": 3051.76,
        "transcript": "Tuamta-llu wangkuta Yugni uumek tua-i nalluvkenata:",
        "translation": "Then, we Yupiit also know this:"
    },
    "357": {
        "startTime": 3052.32,
        "endTime": 3064.2,
        "transcript": "Atunem ciuniurtaagutlerput, atunem-llu tua-i ilaliurutlerput uuggun elluarucitun ilaliurucarakun.",
        "translation": "Welcoming each other, and socializing with each other with this right way of socializing."
    },
    "358": {
        "startTime": 3064.2,
        "endTime": 3074.43,
        "transcript": "Tua-i una wani waten ayuqellerput caknerpak akulemteńi angkacagartuq.",
        "translation": "Our behavior like this among ourselves is very important."
    },
    "359": {
        "startTime": 3074.43,
        "endTime": 3082.5,
        "transcript": "Takarnarqucia-llu tua-i tuaten ayuqerrlainarluni, takarnairucuunani-llu.",
        "translation": "And its need to be respected is always like that, and never loses it."
    },
    "360": {
        "startTime": 3102.44,
        "endTime": 3107.62,
        "transcript": "Qanikcaq tangerrluku yullret imkut pitullruut.",
        "translation": "People back then would look at the snow."
    },
    "361": {
        "startTime": 3107.62,
        "endTime": 3114.82,
        "transcript": "Qanikci'rqan cali-llu ciku, tua-i-w' cikuli'rqan cikurrlugluni",
        "translation": "When there's a lot of snow, and the ice, when there's a lot of ice"
    },
    "362": {
        "startTime": 3115.64,
        "endTime": 3123.21,
        "transcript": "Qanikcaam akulii cikuluku piaqan, nenglaiteqtaarluni-w' tua-i",
        "translation": "When there's ice between layers of snow, when it's been repeatedly warming up"
    },
    "363": {
        "startTime": 3123.21,
        "endTime": 3131.24,
        "transcript": "Tamana-gguq tua-i qanikci'rqan, qau͡gna-llu kiatvut qanikci'rqan mel'ituuq. Mel'irnilallruat.",
        "translation": "When there's a lot of snow, and a lot of snow upriver from us, there's a lot of melt off. They'd say there'd be a lot of melt off."
    },
    "364": {
        "startTime": 3131.24,
        "endTime": 3138.18,
        "transcript": "Qanikcinqurraa-qaa elpet tangvallruan, qanikcinkacagallrani?",
        "translation": "Did you see a snowier time when there was a lot of snow?"
    },
    "365": {
        "startTime": 3138.18,
        "endTime": 3143.2,
        "transcript": "Qanikcitullruuq imumi mikluta. Maani qanikcipiatullruuq.",
        "translation": "There used to be a lot of snow back when we were small. There used to be a lot of snow here."
    },
    "366": {
        "startTime": 3143.2,
        "endTime": 3152.34,
        "transcript": "Enet-llu kankut mission house-at kiimeng qertullrulriit roof-ai tekilluki piaqluni atrarluni.",
        "translation": "And the buildings down there, the mission house was the only tall one, and it would reach the roof going down."
    },
    "367": {
        "startTime": 3152.34,
        "endTime": 3155.7,
        "transcript": "Mayurluta pagaavet ellu'urtaaraqluta.",
        "translation": "We'd climb up there and slide."
    },
    "368": {
        "startTime": 3155.7,
        "endTime": 3160.8,
        "transcript": "Elaturrat-llu amiiget qanikciurluki waten piaqluki igteńguluteng.",
        "translation": "And we'd shovel the doors of the porches like this into a den."
    },
    "369": {
        "startTime": 3160.8,
        "endTime": 3167.15,
        "transcript": "Qaillun, waten maa-i February-q nangyartulria, qaillun tamaani uptelallruat up'nerkiyallerkameggnun?",
        "translation": "How, with February ending now, how would they prepare to go to spring camp back then?"
    },
    "370": {
        "startTime": 3167.15,
        "endTime": 3171.67,
        "transcript": "Up'nerkiyaqata'arqameng-wa April-aami uptenglallrulriit.",
        "translation": "When they were going to go to spring camp, they'd start preparing in April."
    },
    "371": {
        "startTime": 3171.67,
        "endTime": 3176.05,
        "transcript": "Qaniilarluteng-llu canek neqkameggnek up'nerkarpak.",
        "translation": "And they'd prepare their food supplies for the spring."
    },
    "372": {
        "startTime": 3177.18,
        "endTime": 3181.75,
        "transcript": "Pelatekateng-llu civcarturluki, and...",
        "translation": "They'd go set up their tents, and..."
    },
    "373": {
        "startTime": 3181.75,
        "endTime": 3184.25,
        "transcript": "Atam-llu qitevcugniartua.",
        "translation": "Watch, I'll slip into English."
    },
    "374": {
        "startTime": 3185.01,
        "endTime": 3192.35,
        "transcript": "Pinek-llu, angyateng-llu call' ayaulluki, aguuteteng-llu.",
        "translation": "And, you know, they'd bring their boats, and their open canoes."
    },
    "375": {
        "startTime": 3192.35,
        "endTime": 3196.8,
        "transcript": "Cat tua-i aturyugarkateng up'nerkillerni ayaulluki.",
        "translation": "They'd bring things they'd need to use in the spring camps."
    },
    "376": {
        "startTime": 3196.8,
        "endTime": 3205.36,
        "transcript": "Nutaan-llu April-aaq man'a qukallra kituan nutaan wangkuta upagluta.",
        "translation": "Then when the middle of April passed, we'd move."
    },
    "377": {
        "startTime": 3205.36,
        "endTime": 3211.99,
        "transcript": "Tua-i tekilluta nunakamteńun. Cakneq tua-i assirluni nunaniqluni.",
        "translation": "We'd arrive to our settlements. It was very good and pleasant."
    },
    "378": {
        "startTime": 3236.88,
        "endTime": 3241.94,
        "transcript": "Tua-i-ll' mat'um nalliini waten cali qanlartut:",
        "translation": "Then these days, they also say this:"
    },
    "379": {
        "startTime": 3242.16,
        "endTime": 3251.0,
        "transcript": "Arnanek-gguq irnialek arnaq, atam-gguq taum arnam aanani tangvagniaraa enem iluani.",
        "translation": "They said a woman with femal children, watch, that woman will watch her mother in the home."
    },
    "380": {
        "startTime": 3251.0,
        "endTime": 3258.88,
        "transcript": "Tua-i-llu-gguq calillra, callra arnam cali taum irniaran ayuqeliyugngaluku.",
        "translation": "Then they said that woman, her child, will be able to replicate her chores, what she does."
    },
    "381": {
        "startTime": 3260.15,
        "endTime": 3262.85,
        "transcript": "Piciugut makut.",
        "translation": "These are true."
    },
    "382": {
        "startTime": 3262.85,
        "endTime": 3268.87,
        "transcript": "Wiinga-ll' waniw' nine-aanek irniangqertua, five girls, four boys.",
        "translation": "And now, I have nine children, five girls, four boys."
    },
    "383": {
        "startTime": 3268.98,
        "endTime": 3278.24,
        "transcript": "Ukut-llu five girls ayuqenritut tamarmeng. Iciw' ayuqenritut.",
        "translation": "And these five girls are all different. You know, they're different."
    },
    "384": {
        "startTime": 3281.07,
        "endTime": 3285.0,
        "transcript": "Tamalkuita-ll' taukut wii kenkepiarluki.",
        "translation": "And I love all of them very much."
    },
    "385": {
        "startTime": 3285.25,
        "endTime": 3290.88,
        "transcript": "Tua-i-ll' caliyaurcama, cali mingeqsaurcama tua-i",
        "translation": "Then when I started making things, and when I started sewing"
    },
    "386": {
        "startTime": 3290.88,
        "endTime": 3296.37,
        "transcript": "Ukut-ll' angliriluteng, ukut yuungnaqengluteng paniinka",
        "translation": "And these grew up, my daughters started living on their own"
    },
    "387": {
        "startTime": 3297.18,
        "endTime": 3301.22,
        "transcript": "Caliurnaunka mingqurluki-ll'.",
        "translation": "I'd make them things, and sew things for them."
    },
    "388": {
        "startTime": 3301.41,
        "endTime": 3310.56,
        "transcript": "Iliini enaitnun it'lartua cailkami taun im' mingqelqa. Umyuaqa tang pinaurtuq.",
        "translation": "I sometimes go in their homes, and what I sewed is on the floor. I would feel unhappy."
    },
    "389": {
        "startTime": 3310.68,
        "endTime": 3316.26,
        "transcript": "Cunawa-m' tua-i assircaarluku tang tauna uitaarkaq cailkamtelluku.",
        "translation": "Apparently, they'd leave leave on the floor what was supposed to be kept well."
    },
    "390": {
        "startTime": 3316.26,
        "endTime": 3320.25,
        "transcript": "Iliinun panima iternaurtua, neat.",
        "translation": "I'd go into one of my daughter's, [and it's] neat."
    },
    "391": {
        "startTime": 3321.25,
        "endTime": 3325.96,
        "transcript": "Aren caliallrenka-ll' makut kenkumaluteng.",
        "translation": "Oh my, what I made would be treated with love."
    },
    "392": {
        "startTime": 3326.32,
        "endTime": 3336.86,
        "transcript": "Tua-i-ll' tuaten piama waniwa irniamni five girls, malruk, atrit aperngaitanka",
        "translation": "Then when I do that, these among my children of five girls, two of them, I won't say their names"
    },
    "393": {
        "startTime": 3337.37,
        "endTime": 3344.12,
        "transcript": "Wii tangerturallemni neat, Kass'at apqiitnek neat.",
        "translation": "They're neat from what I've seen, what they call neat in English."
    },
    "394": {
        "startTime": 3344.66,
        "endTime": 3346.38,
        "transcript": "Assirtuk.",
        "translation": "They're good."
    },
    "395": {
        "startTime": 3346.38,
        "endTime": 3349.73,
        "transcript": "Tamarmeng assiryaaqut.",
        "translation": "They're all good."
    },
    "396": {
        "startTime": 3349.73,
        "endTime": 3358.97,
        "transcript": "Tua-i-ll' waten piunga: mingqaallrenka aturiallrenka taukuk care-aqapiarluki.",
        "translation": "Then I realized this: they take great care of the clothes I sewed."
    },
    "397": {
        "startTime": 3358.97,
        "endTime": 3367.64,
        "transcript": "Arcaqerluni-am aipaan care-aamiki, eniinun itraqama tua-i tanglaamteki",
        "translation": "Because the other takes especially good care of them, since we see them when we go into her house"
    },
    "398": {
        "startTime": 3368.81,
        "endTime": 3381.85,
        "transcript": "Kiagmi caliallrenka mingqaat atkuut, piluguut, furs, fur clothes, kiagmi tangerqayuitanka eniin iluani, nothing.",
        "translation": "In the summer, the clothes I sewed, parkas, skin boots, furs, fur clothes, I never see them in her house in the summer, nothing."
    },
    "399": {
        "startTime": 3382.23,
        "endTime": 3385.04,
        "transcript": "She put them away.",
        "translation": "She put[s] them away."
    },
    "400": {
        "startTime": 3385.82,
        "endTime": 3388.35,
        "transcript": "Iciw' put away-larai.",
        "translation": "You know, she puts them away."
    },
    "401": {
        "startTime": 3388.35,
        "endTime": 3397.78,
        "transcript": "Kass'ani nallunritua fur-at uitavingqertut pitalqellriamek enemek.",
        "translation": "I know that in the West, furs have appropriate places to be."
    },
    "402": {
        "startTime": 3397.78,
        "endTime": 3405.14,
        "transcript": "Kiircetevkenani, nengllirpek'nani, maybe meduim, tua-i-ll' fur-ani assirluni.",
        "translation": "It's not hot, it's not cold, maybe meduim, and the fur is good."
    },
    "403": {
        "startTime": 3405.14,
        "endTime": 3416.09,
        "transcript": "Atam cat wani makut skin-at agaurarqameng years and years aturviirutetuut uuluteng.",
        "translation": "You see, when these skin clothes hang for years and years, they become unusable [?from wearing out]."
    },
    "404": {
        "startTime": 3416.74,
        "endTime": 3421.3,
        "transcript": "Tegukumni-ll' un' atkuk allegluni. Uuluni.",
        "translation": "And when I take this parka, it rips. [?It wears out]."
    },
    "405": {
        "startTime": 3442.17,
        "endTime": 3450.5,
        "transcript": "Yuilqumi-gguq tarrisnginanemni ilamnek arenqiallugtellriamek tangerquma",
        "translation": "They said that if I see one of my peers in misfortune as I travel in the wilderness"
    },
    "406": {
        "startTime": 3450.5,
        "endTime": 3454.14,
        "transcript": "Pirrangqertacimtun ikayuakilaku.",
        "translation": "I should help him with whatever I have."
    },
    "407": {
        "startTime": 3454.14,
        "endTime": 3456.67,
        "transcript": "Alerquumaluta tuaten.",
        "translation": "That's how we were instructed."
    },
    "408": {
        "startTime": 3456.67,
        "endTime": 3464.2,
        "transcript": "Wall'u imarkailkan, wall'u neqkailkan neqkaramnek tuaken avgutesqelluku.",
        "translation": "Or if he has no bullets, or is without food, I should give him some of what food I have."
    },
    "409": {
        "startTime": 3464.54,
        "endTime": 3468.03,
        "transcript": "Cali-llu pinauraitkut waten wani:",
        "translation": "They'd also tell us this:"
    },
    "410": {
        "startTime": 3469.01,
        "endTime": 3477.02,
        "transcript": "Waniwa-gguq atam cam iliini, ertem iliini pikailkumta",
        "translation": "They said that someday, if we lack something one day"
    },
    "411": {
        "startTime": 3477.02,
        "endTime": 3481.91,
        "transcript": "Waten pikailkumta uninraarturngaitukut.",
        "translation": "When we lack something, we will not be [?robust]."
    },
    "412": {
        "startTime": 3482.24,
        "endTime": 3488.24,
        "transcript": "Anrutam-gguq qam'um imaitellra anglanarqenrituq.",
        "translation": "Theys ay having an empty stomach is not enjoyable."
    },
    "413": {
        "startTime": 3488.77,
        "endTime": 3502.52,
        "transcript": "Yuum-gguq tamarmi ayuqucian nangteqsaram angenqaa anrutam qamum imaunani nangtequteqellra.",
        "translation": "They say that one trait among every person is that the greatest suffering is suffering an empty stomach."
    },
    "414": {
        "startTime": 3502.63,
        "endTime": 3507.67,
        "transcript": "Pinirnaunani, uninraarnaunani-llu.",
        "translation": "We become weak, and [?without vigor]."
    },
    "415": {
        "startTime": 3507.86,
        "endTime": 3520.86,
        "transcript": "Cali-llu neqa, elliin imna neqa qel'kenritqallrulliu, wall'u neqa egtellrukuniu nernarqengraan",
        "translation": "Also, if that person does not keep food, or throws food away though it's edible"
    },
    "416": {
        "startTime": 3521.13,
        "endTime": 3527.5,
        "transcript": "Tailuni umyugaanun, tailuni, uurcaraluni arenqiapaa.",
        "translation": "When it comes into his mind, when he regrets what he forsook, how unfortunate."
    },
    "417": {
        "startTime": 3527.5,
        "endTime": 3532.45,
        "transcript": "\"Imna-llu kitak' nerurallrulaku egtevkenaku.\"",
        "translation": "\"I should've eaten that instead of throwing it away.\""
    },
    "418": {
        "startTime": 3532.45,
        "endTime": 3536.67,
        "transcript": "Tuaten-gguq atam ayuquq.",
        "translation": "They said that's what it's like."
    },
    "419": {
        "startTime": 3536.67,
        "endTime": 3544.39,
        "transcript": "Ca-gguq tamalkuan umyuamikun aglumayagulluku waten kaigluni.",
        "translation": "They say he begins to covet everything in his mind in his hunger like this."
    },
    "420": {
        "startTime": 3544.39,
        "endTime": 3552.61,
        "transcript": "Maa-i makut wani arcaqerluki wangkuta qanruyutektuaput.",
        "translation": "This is the important wisdom that we pass down."
    },
    "421": {
        "startTime": 3552.61,
        "endTime": 3560.75,
        "transcript": "Cali-llu uksumi waten nenglem nalliini",
        "translation": "Also, in the winter like this during the cold season"
    },
    "422": {
        "startTime": 3560.86,
        "endTime": 3568.09,
        "transcript": "Angussaagaqamta nutaan cakviutuamta",
        "translation": "Since we especially struggle when we hunt"
    },
    "423": {
        "startTime": 3569.2,
        "endTime": 3572.83,
        "transcript": "Tua-i caunata ayaasqevkenata.",
        "translation": "They told us not to travel without anything."
    },
    "424": {
        "startTime": 3572.99,
        "endTime": 3579.5,
        "transcript": "Qanikciurutaunata cikuliurutaunata-llu ayaasqevkenata.",
        "translation": "They told us not to travel without a shovel and an ice pick."
    },
    "425": {
        "startTime": 3579.95,
        "endTime": 3587.74,
        "transcript": "Cali-llu makut kuiget atrit atengqercelluki.",
        "translation": "We should also know the names of these rivers."
    },
    "426": {
        "startTime": 3588.32,
        "endTime": 3601.45,
        "transcript": "Yuum-gguq atam iliin yuk pikaitem nalliini taum-llu neq'rugalgem nuniini nangernganiartuq atra nallukuniu.",
        "translation": "They said that one person, you see, during a famine may stand around a place with a lot of fish if he doesn't know its name."
    },
    "427": {
        "startTime": 3605.07,
        "endTime": 3613.24,
        "transcript": "Yuilqumi pingnatugyarat tamalkuita acirturluki piuratulliniit imkut yuut",
        "translation": "The people back then would name all of the subsistence areas in the wilderness"
    },
    "428": {
        "startTime": 3613.24,
        "endTime": 3617.35,
        "transcript": "Nernarqellriit neqait ayuqenrilnguut.",
        "translation": "The place with various edible food."
    },
    "429": {
        "startTime": 3617.35,
        "endTime": 3626.69,
        "transcript": "Yuum-gguq atra nallukuniu taum kuigem apertuumangraan neqengqerrucia nallua.",
        "translation": "They said that if a person doesn't know that river's name, he doesn't know that it has fish though it's indicated."
    },
    "430": {
        "startTime": 3626.95,
        "endTime": 3637.35,
        "transcript": "Taumek qanrucimaukut, nunam-gguq qaingani, kuiget-llu, nanvarraat-llu atrit cali elisnganarqaput",
        "translation": "That's why we're told that we should know the names of things on land, rivers, and lakes"
    },
    "431": {
        "startTime": 3637.35,
        "endTime": 3640.77,
        "transcript": "Angussaagyarat, nerengnaqsarat.",
        "translation": "The places to hunt, to subsist."
    },
    "432": {
        "startTime": 3640.77,
        "endTime": 3645.16,
        "transcript": "Makut maa-i qanruyutektuaput.",
        "translation": "This is the traditional knowledge we pass down."
    },
    "433": {
        "startTime": 3645.16,
        "endTime": 3653.66,
        "transcript": "Tau͡gken neqaicuilnguut aperturluki cali.",
        "translation": "However, we should also indicate the ones that always have fish."
    },
    "434": {
        "startTime": 3653.66,
        "endTime": 3657.38,
        "transcript": "Qau͡gna-gguq qava-i Ecuilnguq neqaicuituq.",
        "translation": "Say that Ecuilnguq upriver always has fish."
    },
    "435": {
        "startTime": 3657.75,
        "endTime": 3664.37,
        "transcript": "\"I also hear that the area around Qagatmiut inland always has fish.\"",
        "translation": "\"I also hear that the area around Qagatmiut inland always has fish.\""
    },
    "436": {
        "startTime": 3664.41,
        "endTime": 3674.39,
        "transcript": "Ingrit-gguq makut carvanilriit, maaken ingrinek carvnilria neqem-gguq caumanriyuitaa.",
        "translation": "Say that the flowing waters in these mountains, fish don't stop going to the waters flowing from this mountain."
    },
    "437": {
        "startTime": 3674.39,
        "endTime": 3684.51,
        "transcript": "\"Nalayuituq-gguq uksumi caumaurarqamni qallalluni waten pilria wii.\"",
        "translation": "\"This churning water does not die out in the winter when I go to it.\""
    },
    "438": {
        "startTime": 3684.98,
        "endTime": 3696.7,
        "transcript": "Tamakut ullagluki nallunrikumteki, wall'u manarluta, wall'u kuvyirluta angungnaquraasqelluta pilaraitkut.",
        "translation": "They tell us to go there if we know them, or fish, or set drift nets and subsist."
    }
};